import React from "react";
import { Link } from "react-router-dom";
import { profileUpdateService } from "../Network/services/profileUpdateService";
import $ from "jquery";
import Popper from "popper.js";
import Modal from "react-modal";
import ReactFormInputValidation from "react-form-input-validation";
import agent from "../agent";
import { userService } from "../Network/services/userService";
import { commonService } from "../Network/services/commonService";
import { GoogleLogin, googleLogout } from '@react-oauth/google';
import StorageHelper from "../utils/storageHelper";
import LocationAutocomplete from "./LocationAutocomplete/LocationAutocomplete";
import ReactPasswordToggleIcon from 'react-password-toggle-icon';
import linkedinImage from "../assets/images/linkedin.png";
import googleImage from "../assets/images/google.png";
import { connect } from "react-redux";
import { LoadingOverlay, Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import { useLocation, useHistory, withRouter } from "react-router-dom";
import history from './history'
import { geolocated } from "react-geolocated";
import Geocode from "react-geocode";
import NavigationBtn from "../components/Notifications/NotificationBtn";
import {
  UPDATE_FIELD_AUTH,
  LOGIN,
  REGISTER,
  LOGIN_PAGE_UNLOADED,
} from "../constants/actionTypes";
import { ToastContainer, toast } from "react-toastify";

const {promiseStatus} = require('promise-status-async');

const getForgotPassAttemptsKey = (identifier) => `otp_forgotpass_attempts_${identifier}`;
const getForgotPassBlockKey = (identifier) => `otp_forgotpass_block_${identifier}`;
const getForgotPassLockKey = (identifier) => `otp_forgotpass_lock_${identifier}`;
const getForgotPassCooldownKey = (identifier) => `otp_forgotpass_cooldown_${identifier}`; // 30-second cooldown key

const isForgotPassAPICallInProgress = (identifier) => {
  if (!identifier) return false;
  const lockKey = getForgotPassLockKey(identifier);
  const lockData = sessionStorage.getItem(lockKey);
  
  if (!lockData) return false;
  
  const lockTime = parseInt(lockData, 10);
  const currentTime = Date.now();
  const fiveSeconds = 5000;
  
  if (currentTime - lockTime < fiveSeconds) {
    return true;
  } else {
    sessionStorage.removeItem(lockKey);
    return false;
  }
};

const setForgotPassAPICallLock = (identifier) => {
  if (!identifier) return;
  const lockKey = getForgotPassLockKey(identifier);
  sessionStorage.setItem(lockKey, Date.now().toString());
};

const removeForgotPassAPICallLock = (identifier) => {
  if (!identifier) return;
  const lockKey = getForgotPassLockKey(identifier);
  sessionStorage.removeItem(lockKey);
};

const isForgotPassBlocked = (identifier) => {
  if (!identifier) return false;
  
  const blockKey = getForgotPassBlockKey(identifier);
  const blockData = localStorage.getItem(blockKey);
  
  if (!blockData) return false;
  
  try {
    const blockInfo = JSON.parse(blockData);
    const blockTime = blockInfo.timestamp;
    const currentTime = Date.now();
    const timeElapsed = currentTime - blockTime;
    const fiveMinutes = 30 * 60 * 1000; // 30 minutes 
    
    if (timeElapsed < fiveMinutes) {
      return true;
    } else {
      localStorage.removeItem(blockKey);
      localStorage.removeItem(getForgotPassAttemptsKey(identifier));
      sessionStorage.removeItem(getForgotPassLockKey(identifier));
      return false;
    }
  } catch (error) {
    return false;
  }
};

const getForgotPassAttemptsCount = (identifier) => {
  if (!identifier) return 0;
  const attemptsKey = getForgotPassAttemptsKey(identifier);
  const attemptsData = localStorage.getItem(attemptsKey);
  return attemptsData ? parseInt(attemptsData, 10) : 0;
};

const setForgotPassAttemptsCount = (identifier, count) => {
  if (!identifier) return;
  const attemptsKey = getForgotPassAttemptsKey(identifier);
  localStorage.setItem(attemptsKey, count.toString());
};

const blockForgotPassUser = (identifier) => {
  if (!identifier) return;
  const blockKey = getForgotPassBlockKey(identifier);
  const blockData = {
    timestamp: Date.now(),
    identifier: identifier
  };
  localStorage.setItem(blockKey, JSON.stringify(blockData));
  const cooldownKey = getForgotPassCooldownKey(identifier);
  sessionStorage.removeItem(cooldownKey);
};

const getForgotPassRemainingTime = (identifier) => {
  if (!identifier) return null;
  
  const blockKey = getForgotPassBlockKey(identifier);
  const blockData = localStorage.getItem(blockKey);
  if (!blockData) return null;

  try {
    const blockInfo = JSON.parse(blockData);
    const blockTime = blockInfo.timestamp;
    const currentTime = Date.now();
    const timeElapsed = currentTime - blockTime;
    const fiveMinutes = 30 * 60 * 1000; // 30 minutes 
    const remainingTime = fiveMinutes - timeElapsed;

    if (remainingTime > 0) {
      const remainingMinutes = Math.ceil(remainingTime / (60 * 1000));
      return remainingMinutes;
    }
  } catch (error) {
    return null;
  }

  return null;
};

const isForgotPassOnCooldown = (identifier) => {
  if (!identifier) return false;
  const cooldownKey = getForgotPassCooldownKey(identifier);
  const cooldownData = sessionStorage.getItem(cooldownKey);
  
  if (!cooldownData) return false;
  
  const cooldownTime = parseInt(cooldownData, 10);
  const currentTime = Date.now();
  const thirtySeconds = 30 * 1000;
  
  if (currentTime - cooldownTime < thirtySeconds) {
    return true;
  } else {
    sessionStorage.removeItem(cooldownKey);
    return false;
  }
};

const setForgotPassCooldown = (identifier) => {
  if (!identifier) return;
  const cooldownKey = getForgotPassCooldownKey(identifier);
  sessionStorage.setItem(cooldownKey, Date.now().toString());
};

const getForgotPassCooldownRemainingTime = (identifier) => {
  if (!identifier) return null;
  const cooldownKey = getForgotPassCooldownKey(identifier);
  const cooldownData = sessionStorage.getItem(cooldownKey);
  
  if (!cooldownData) return null;
  
  const cooldownTime = parseInt(cooldownData, 10);
  const currentTime = Date.now();
  const thirtySeconds = 30 * 1000;
  const remainingTime = thirtySeconds - (currentTime - cooldownTime);
  
  if (remainingTime > 0) {
    const remainingSeconds = Math.ceil(remainingTime / 1000);
    return remainingSeconds;
  }
  
  return null;
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onChangeEmail: (value) =>
    dispatch({ type: UPDATE_FIELD_AUTH, key: "email", value }),
  onChangePassword: (value) =>
    dispatch({ type: UPDATE_FIELD_AUTH, key: "password", value }),
  onSubmit: (res) => dispatch({ type: LOGIN, payload: Promise.resolve(res) }),
  onRegisterSubmit: (res) =>
    dispatch({ type: REGISTER, payload: Promise.resolve(res) }),
  onUnload: () => dispatch({ type: LOGIN_PAGE_UNLOADED }),
});

let location = ""
const baseLink = ""
const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const LINKEDIN_CLIENT_ID = "861t2r6iqhs96v";
const REDIRECT_URI = `${process.env.REACT_APP_URL}linkedin-web-auth`;
const SCOPE = "openid%20profile%20email";

const { OAuth2Client } = require('google-auth-library')

const getDecodedOAuthJwtGoogle = async token => {
  try {
    const client = new OAuth2Client(CLIENT_ID)
    const ticket = await client.verifyIdToken({
      idToken: token,
      audience: CLIENT_ID,
    })
    return ticket
  } catch (error) {
    return { status: 500, data: error }
  }
}

class Header extends React.Component {
  constructor(props) {
    super();
    this.inputRef = React.createRef();
    this.inputRef1 = React.createRef();
    this.newPassword1 = React.createRef();
    this.confirmNewPassword = React.createRef();
    
    this.state = {
      registerModelIsOpen: false,
      registerTwoModelIsOpen: false,
      loginModelIsOpen: false,
      successPopupOpen: false,
      termsPopupIsOpen: false,
      privacyPopupIsOpen: false,
      emailOTPPopupIsOpen: false,
      mobileOTPPopupIsOpen: false,
      socialRegisterIsOpen: false,
      isSocialRegister: false,
      forgotPassIsOpen: false,
      resetPassIsOpen: false,
      isLogin: true,
      isRegisterTwo: false,
      isCompany: false,
      isService: false,
      isBoth: false,
      selectedLookingFor: "freelance", 
      email: "",
      password: "",
      confirmpassword: "",
      first_name: "",
      last_name: "",
      type: "",
      mobile: "",
      mobileOTP: "",
      emailOTP: "",
      isloginLoading: false,
      isregisterLoading: false,
      isloading: false,
      isLoggedIn: false,
      lat: "",
      long: "",
      forgotpass: "",
      otp: "",
      newPass: "",
      confirmNewpass: "",
      mobileDropdownOpen: false,
      fields: {
        name: "",
        email: "",
        phone_number: "",
        password: "",
        confirmpassword: "",
        firstName: "",
        lastName: "",
        location: "",
        aadhar: "",
        referralCode: "",
      },
      errors: {},
      isFormValid: false,
      isLoginFormValid: false,
      isForgotPassValid: false,
      termsAccepted: false,
      forgotPassIdentifier: "",
      remainingForgotPassMinutes: null,
      remainingForgotPassCooldownSeconds: null, // For 30-sec cooldown
      isGettingLocation: false,
    };

    this.form = new ReactFormInputValidation(this);
    
    const originalHandleSubmit = this.form.handleSubmit;
    this.form.handleSubmit = (event) => {
      event.preventDefault();
      
      if (this.state.isLogin && this.state.isloginLoading) {
        return false;
      }
      
      if (!this.state.isLogin && this.state.isregisterLoading) {
        return false;
      }
      
      const isFormValid = this.state.isLogin ? this.state.isLoginFormValid : this.state.isFormValid;
      
      if (!isFormValid) {
        this.setState({ errors: {} });
        
        if (this.state.isLogin) {
          const nameField = document.querySelector('input[name="name"]');
          const passwordField = document.querySelector('input[name="password"]');
          
          if (!this.state.fields.name && nameField) {
            nameField.style.border = '1px solid #dc3545';
            nameField.classList.add('validation-error');
            setTimeout(() => {
              nameField.style.removeProperty('border');
              nameField.classList.remove('validation-error');
            }, 3000);
          }
          
          if (!this.state.fields.password && passwordField) {
            passwordField.style.border = '1px solid #dc3545';
            passwordField.classList.add('validation-error');
            setTimeout(() => {
              passwordField.style.removeProperty('border');
              passwordField.classList.remove('validation-error');
            }, 3000);
          }
        } else {
          this.scrollToFirstEmptyField();
        }
        return false;
      }
      
      try {
        const result = originalHandleSubmit.call(this.form, event);
        
        if (isFormValid) {
          let formElement = null;
          if (event.target.tagName === 'BUTTON') {
            formElement = event.target.closest('form');
            if (!formElement) {
              const modalBody = event.target.closest('.register-modal-body');
              if (modalBody) {
                formElement = modalBody.querySelector('form');
              }
            }
            if (!formElement) {
              formElement = {
                firstName: document.querySelector('input[name="firstName"]'),
                lastName: document.querySelector('input[name="lastName"]'),
                email: document.querySelector('input[name="email"]'),
                phone_number: document.querySelector('input[name="phone_number"]'),
                password: document.querySelector('input[name="password"]'),
                confirmpassword: document.querySelector('input[name="confirmpassword"]'),
                terms: document.querySelector('input[name="terms"]')
              };
            }
          } else {
            formElement = event.target;
          }
          
          let formData;
          
          if (this.state.isLogin) {
            const nameInput = formElement?.querySelector?.('input[name="name"]') || formElement?.name;
            const passwordInput = formElement?.querySelector?.('input[name="password"]') || formElement?.password;
            
            formData = {
              name: nameInput?.value || this.state.fields.name || "",
              password: passwordInput?.value || this.state.fields.password || ""
            };
          } else {
            formData = {
              firstName: formElement?.firstName?.value || "",
              lastName: formElement?.lastName?.value || "",
              email: formElement?.email?.value || "",
              phone_number: formElement?.phone_number?.value || "",
              password: formElement?.password?.value || "",
              confirmpassword: formElement?.confirmpassword?.value || "",
              terms: formElement?.terms?.checked || false
            };
          }
          
          this.form.onformsubmit(formData);
        }
        
        return result;
      } catch (error) {
        event.preventDefault();
        return false;
      }
    };
    
    this.setValidationRules();
    
    this.form.onformsubmit = (fields) => {
      if (this.state.isLogin) {
        if (!this.state.isloginLoading) {
          this.login(fields.name, fields.password);
        }
      } else {
        this.setState((state) => ({ isSocialRegister: false }));
        this.openRegisterTwoModal();
        this.closeRegisterModal();
        this.setState((state) => ({
          email: fields.email,
          password: fields.password,
          confirmpassword: fields.confirmpassword,
          first_name: fields.firstName,
          last_name: fields.lastName,
          mobile: fields.phone_number,
          fields: {
            ...state.fields,
            firstName: fields.firstName,
            lastName: fields.lastName,
            email: fields.email,
            phone_number: fields.phone_number,
            password: fields.password,
            confirmpassword: fields.confirmpassword,
          }
        }), () => {
          this.validateForm();
        });
      }
    }
  }

  setValidationRules = () => {
    if (this.state.isLogin) {
      this.form.useRules({
        name: "required",
        password: "required|min:6",
      });
    } else if (this.state.isRegisterTwo) {
      this.form.useRules({
        location: "required",
      });
    } else {
      this.form.useRules({
        firstName: "required|min:1|max:30",
        lastName: "required|min:1|max:30",
        email: "required|email",
        phone_number: "required",
        password: "required|min:6",
        confirmpassword: "required",
      });
    }
  };

  validateLoginForm = () => {
    const { fields } = this.state;
    const nameValid = fields.name && fields.name.toString().trim().length > 0;
    const passwordValid = fields.password && fields.password.toString().trim().length > 0;
    
    const isLoginFormValid = nameValid && passwordValid;
    this.setState({ isLoginFormValid });
    return isLoginFormValid;
  };

  validateForgotPasswordForm = () => {
    const { forgotpass } = this.state;
    const isForgotPassValid = forgotpass && forgotpass.toString().trim().length > 0;
    
    this.setState({ isForgotPassValid });
    return isForgotPassValid;
  };

  validateForm = () => {
    const { fields, termsAccepted } = this.state;
    const requiredFields = ['firstName', 'lastName', 'email'];
    
    if (!this.state.isSocialRegister) {
      requiredFields.push('phone_number');
    }
    
    if (!this.state.isSocialRegister) {
      requiredFields.push('password', 'confirmpassword');
    }
    
    if (this.state.isRegisterTwo) {
      requiredFields.push('location');
    }
    
    const allFieldsFilled = requiredFields.every(field => 
      fields[field] && fields[field].toString().trim().length > 0
    );
    
    let passwordsMatch = true;
    if (!this.state.isSocialRegister) {
      const passwordStr = fields.password ? fields.password.toString() : '';
      const hasMinLength = passwordStr.length >= 8;
      const hasUpperCase = /[A-Z]/.test(passwordStr);
      const hasNumber = /[0-9]/.test(passwordStr);
      const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(passwordStr);
      const isValidPassword = hasMinLength && hasUpperCase && hasNumber && hasSpecialChar;
      passwordsMatch = fields.password === fields.confirmpassword && fields.password && isValidPassword;
    }
    
    const emailValid = fields.email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fields.email.toString());
   
    let phoneValid = true;
    if (!this.state.isSocialRegister) {
      const rawPhone = (fields.phone_number || '').toString().trim();
      const digitsOnly = rawPhone.replace(/\D/g, '');
      const normalized = digitsOnly.startsWith('91') && digitsOnly.length === 12
        ? digitsOnly.slice(2)
        : (digitsOnly.startsWith('0') ? digitsOnly.slice(1) : digitsOnly);
      phoneValid = /^[6-9]\d{9}$/.test(normalized);
    }
    const firstNameTrimmed = fields.firstName ? fields.firstName.toString().trim() : '';
    const lastNameTrimmed = fields.lastName ? fields.lastName.toString().trim() : '';
    const nameValid = firstNameTrimmed.length >= 1 && firstNameTrimmed.length <= 30 && 
                     lastNameTrimmed.length >= 1 && lastNameTrimmed.length <= 30;
    
    const locationValid = this.state.isRegisterTwo ? 
      (fields.location && fields.location.toString().trim().length > 0) : true;
    
    const isFormValid = allFieldsFilled && passwordsMatch && emailValid && phoneValid && nameValid && 
                       locationValid && (this.state.isRegisterTwo ? termsAccepted : true);
    
    this.setState({ isFormValid });
    return isFormValid;
  };

  scrollToFirstEmptyField = () => {
    const { fields, termsAccepted } = this.state;
    const fieldOrder = ['firstName', 'lastName', 'email', 'phone_number', 'password', 'confirmpassword'];
    
    if (this.state.isRegisterTwo) {
      fieldOrder.push('location');
    }
    
    let firstEmptyField = null;
    for (const fieldName of fieldOrder) {
      const fieldValue = fields[fieldName];
      
      if (!fieldValue || fieldValue.toString().trim().length === 0) {
        firstEmptyField = fieldName;
        break;
      }
      
      if (fieldName === 'firstName') {
        const trimmedValue = fieldValue.toString().trim();
        if (trimmedValue.length < 1 || trimmedValue.length > 30) {
          firstEmptyField = fieldName;
          break;
        }
      }
      if (fieldName === 'lastName') {
        const trimmedValue = fieldValue.toString().trim();
        if (trimmedValue.length < 1 || trimmedValue.length > 30) {
          firstEmptyField = fieldName;
          break;
        }
      }
      if (fieldName === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(fieldValue.toString())) {
        firstEmptyField = fieldName;
        break;
      }
      if (fieldName === 'phone_number' && !/^\d{10,12}$/.test(fieldValue.toString())) {
        firstEmptyField = fieldName;
        break;
      }
      if (fieldName === 'password') {
        const passwordStr = fieldValue.toString();
        const hasMinLength = passwordStr.length >= 8;
        const hasUpperCase = /[A-Z]/.test(passwordStr);
        const hasNumber = /[0-9]/.test(passwordStr);
        const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(passwordStr);
        if (!hasMinLength || !hasUpperCase || !hasNumber || !hasSpecialChar) {
          firstEmptyField = fieldName;
          break;
        }
      }
      if (fieldName === 'confirmpassword' && fields.password !== fieldValue) {
        firstEmptyField = fieldName;
        break;
      }
    }
    
    if (!firstEmptyField && this.state.isRegisterTwo && !termsAccepted) {
      firstEmptyField = 'terms';
    }
    
    if (firstEmptyField) {
      const element = document.querySelector(`[name="${firstEmptyField}"]`);
      
      if (element) {
        if (firstEmptyField === 'email') {
          const emailField = document.querySelector('input[name="email"]');
          const modalBody = document.querySelector('.register-modal-body');
          
          if (modalBody) {
            modalBody.scrollTo({
              top: 200,
              behavior: 'smooth'
            });
          }
          
          emailField.style.border = '1px solid #dc3545';
          emailField.classList.add('validation-error');
          emailField.focus();
          
          setTimeout(() => {
            emailField.style.removeProperty('border');
            emailField.classList.remove('validation-error');
          }, 3000);
          
        } else {
          element.scrollIntoView({ 
            behavior: 'smooth', 
            block: 'center' 
          });
    
          element.style.border = '1px solid #dc3545';
          element.classList.add('validation-error');
          element.focus();
          
          setTimeout(() => {
            element.style.removeProperty('border');
            element.classList.remove('validation-error');
          }, 3000);
        }
      }
    }
  };

  preventNumeric = (e) => {
    const char = e.key;
    if (/[0-9]/.test(char)) {
      e.preventDefault();
    }
  };

  handleFieldChange = (event) => {
    this.form.handleChangeEvent(event);
    
    const { name, value } = event.target;
    
    let processedValue = value;
    
    if (name === 'firstName' || name === 'lastName') {
      processedValue = value.replace(/[0-9]/g, '');
    } else if (name === 'referralCode') {
      processedValue = value.toUpperCase();
    }
    
    this.setState(prevState => ({
      fields: {
        ...prevState.fields,
        [name]: processedValue
      },
      errors: (() => {
        const nextErrors = { ...(prevState.errors || {}) };
        if (name === 'phone_number') {
          const digitsOnly = (value || '').toString().trim().replace(/\D/g, '');
          const normalized = digitsOnly.startsWith('91') && digitsOnly.length === 12
            ? digitsOnly.slice(2)
            : (digitsOnly.startsWith('0') ? digitsOnly.slice(1) : digitsOnly);
          const isValid = /^[6-9]\d{9}$/.test(normalized);
          if (value && digitsOnly.length > 0) {
            if (normalized.length !== 10) {
              nextErrors.phone_number = 'Mobile number must be exactly 10 digits';
            } else if (!/^[6-9]/.test(normalized)) {
              nextErrors.phone_number = 'Mobile number must start with 6, 7, 8, or 9';
            } else {
              nextErrors.phone_number = isValid ? '' : 'Enter a valid 10-digit Indian mobile number';
            }
          } else {
            nextErrors.phone_number = '';
          }
        }
        if (name === 'firstName') {
          const trimmedValue = (value || '').toString().trim();
          if (trimmedValue.length === 0) {
            nextErrors.firstName = 'First Name is required';
          } else if (trimmedValue.length > 30) {
            nextErrors.firstName = 'First Name must be 30 characters or less';
          } else {
            nextErrors.firstName = '';
          }
        }
        if (name === 'lastName') {
          const trimmedValue = (value || '').toString().trim();
          if (trimmedValue.length === 0) {
            nextErrors.lastName = 'Last Name is required';
          } else if (trimmedValue.length > 30) {
            nextErrors.lastName = 'Last Name must be 30 characters or less';
          } else {
            nextErrors.lastName = '';
          }
        }
        if (name === 'password') {
          const passwordStr = (value || '').toString();
          if (passwordStr.length > 0) {
            const hasMinLength = passwordStr.length >= 8;
            const hasUpperCase = /[A-Z]/.test(passwordStr);
            const hasNumber = /[0-9]/.test(passwordStr);
            const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(passwordStr);
            
            if (!hasMinLength) {
              nextErrors.password = 'Password must be at least 8 characters';
            } else if (!hasUpperCase) {
              nextErrors.password = 'Password must contain at least 1 uppercase letter';
            } else if (!hasNumber) {
              nextErrors.password = 'Password must contain at least 1 number';
            } else if (!hasSpecialChar) {
              nextErrors.password = 'Password must contain at least 1 special character';
            } else {
              nextErrors.password = '';
            }
          } else {
            nextErrors.password = '';
          }
        }
        if (name === 'confirmpassword') {
          const passwordStr = this.state.fields.password ? this.state.fields.password.toString() : '';
          const confirmPasswordStr = (value || '').toString();
          if (confirmPasswordStr.length > 0 && passwordStr !== confirmPasswordStr) {
            nextErrors.confirmpassword = 'Passwords do not match';
          } else {
            nextErrors.confirmpassword = '';
          }
        }
        return nextErrors;
      })()
    }), () => {
      this.validateForm();
      if (this.state.isLogin) {
        this.validateLoginForm();
      }
    });
  };

  handleTermsChange = (event) => {
    const termsAccepted = event.target.checked;
    this.setState({ termsAccepted }, () => {
      this.validateForm();
    });
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state.forgotPassIdentifier && this.state.forgotPassIdentifier !== prevState.forgotPassIdentifier) {
      if (this.forgotPassInterval) {
        clearInterval(this.forgotPassInterval);
      }
      
      const checkTime = () => {
        const minutes = getForgotPassRemainingTime(this.state.forgotPassIdentifier);
        this.setState({ remainingForgotPassMinutes: minutes });
        
        const cooldownSeconds = getForgotPassCooldownRemainingTime(this.state.forgotPassIdentifier);
        this.setState({ remainingForgotPassCooldownSeconds: cooldownSeconds });
      };
      
      checkTime();
      
      this.forgotPassInterval = setInterval(() => {
        checkTime();
      }, 1000);
    }
    
    if (!this.state.forgotPassIdentifier && this.forgotPassInterval) {
      clearInterval(this.forgotPassInterval);
      this.forgotPassInterval = null;
    }
  }

  componentWillUnmount() {
    if (this.forgotPassInterval) {
      clearInterval(this.forgotPassInterval);
    }
    
    window.removeEventListener('openSocialRegister', this.handleSocialRegister);
    window.removeEventListener('storage', this.handleStorageChange);
    window.removeEventListener('linkedinAuthComplete', this.handleLinkedInAuthComplete);
    delete window.openRegisterModal;
    delete window.openLoginModal;
  }

  componentDidMount() {
    if (localStorage.getItem("isLoggedIn") === null) {
      this.setState((state) => ({
        isLoggedIn: false,
      }));
    } else {
      this.setState((state) => ({
        isLoggedIn: JSON.parse(window.localStorage.getItem("isLoggedIn")),
      }));
    }
    if (localStorage.getItem("isLoggedIn") === true) {
      this.checkOTPVerified();
    }
    
    this.handleSocialRegister = (event) => {
      const { firstname, lastname, email, type } = event.detail;
      this.openSocialRegisterModal(firstname, lastname, email, type);
    };
    
    window.addEventListener('openSocialRegister', this.handleSocialRegister);
    this.handleStorageChange = (e) => {
      if (e.key === 'isLoggedIn') {
        const newLoginState = JSON.parse(e.newValue || 'false');
        this.setState({ isLoggedIn: newLoginState });
      }
    };
    window.addEventListener('storage', this.handleStorageChange);
    this.handleLinkedInAuthComplete = () => {
      const loginState = JSON.parse(localStorage.getItem("isLoggedIn") || 'false');
      this.setState({ isLoggedIn: loginState });
    };
    
    window.addEventListener('linkedinAuthComplete', this.handleLinkedInAuthComplete);
    window.openRegisterModal = (source) => {
      this.openRegisterModal(source || 'landing_page');
    };
    window.openLoginModal = (source) => {
      this.openLoginModal(source || 'landing_page');
    };
    
    const setupMobileDropdown = () => {
      const $ = window.jQuery;
      const screenWidth = window.innerWidth;
      
      if ($ && screenWidth >= 320 && screenWidth <= 400) {
        $(document).off('click touchstart', '.mobile-nav-direct .nav-item.dropdownlinks > a');
        $(document).on('click touchstart', '.mobile-nav-direct .nav-item.dropdownlinks > a', (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          
          const $li = $(e.currentTarget).closest('li');
          const $dropdown = $li.find('ul.dropdown-menu');
          const $link = $(e.currentTarget);
          
          const linkOffset = $link.offset();
          const linkHeight = $link.outerHeight();
          
          $dropdown.toggleClass('show');
          $li.toggleClass('active');
          
          if ($dropdown.hasClass('show')) {
            $dropdown.css({
              'position': 'fixed',
              'top': (linkOffset.top + linkHeight + 4) + 'px',
              'left': '50%',
              'transform': 'translateX(-50%)',
              'z-index': '9999',
              'width': 'auto',
              'min-width': '180px',
              'max-width': '90vw'
            });
          } else {
            $dropdown.css({
              'position': '',
              'top': '',
              'left': '',
              'transform': '',
              'width': '',
              'min-width': '',
              'max-width': ''
            });
          }
          
          this.toggleMobileDropdown(e);
          
          return false;
        });
        
        $(document).off('click', '.mobile-nav-direct-dropdown-close');
        $(document).on('click', (e) => {
          if (!$(e.target).closest('.mobile-nav-direct .nav-item.dropdownlinks').length) {
            $('.mobile-nav-direct .nav-item.dropdownlinks').removeClass('active');
            $('.mobile-nav-direct .nav-item.dropdownlinks .dropdown-menu').removeClass('show').css({
              'position': '',
              'top': '',
              'left': '',
              'transform': '',
              'width': '',
              'min-width': '',
              'max-width': ''
            });
            this.closeMobileDropdown();
          }
        });
      } 
      else if ($ && screenWidth <= 767) {
        const $meanNav = $('.mean-container .mean-nav ul');
        
        if ($meanNav.length) {
          $meanNav.empty();
          
          $meanNav.append(`
            <li class="nav-item">
              <a href="${baseLink}/" class="nav-link active">Explore Jobs</a>
            </li>
          `);
          
          $meanNav.append(`
            <li class="nav-item dropdownlinks">
              <a href="#" class="nav-link active">More <i class="bx bx-chevron-down"></i></a>
              <ul class="dropdown-menu">
                <li class="dd-horizontal"><a href="#" class="nav-link active mobile-dropdown-item" data-action="postjob">Post a Job</a></li>
                <li class="dd-horizontal"><a href="#" class="nav-link active mobile-dropdown-item" data-action="plans">Plans</a></li>
                <li class="dd-horizontal"><a href="${baseLink}/myjobs" class="nav-link active mobile-dropdown-item">My Jobs</a></li>
                <li class="dd-horizontal"><a href="${baseLink}/mycontracts" class="nav-link active mobile-dropdown-item">Jobs I Posted</a></li>
                <li class="dd-horizontal"><a href="${baseLink}/payment" class="nav-link active mobile-dropdown-item"><img src="/assets/images/PaymentsIcon.svg" /> Payment</a></li>
                <li class="dd-horizontal"><a href="#" class="nav-link active mobile-dropdown-item" data-action="disputes"><img src="/assets/images/DisputesIcon.svg" /> Disputes</a></li>
                <li class="dd-horizontal"><a href="#" class="nav-link active mobile-dropdown-item" data-action="referrals"><img src="/assets/images/ReferralsIcon.svg" /> Referrals</a></li>
                <li class="dd-horizontal"><a href="${baseLink}/business" class="nav-link active mobile-dropdown-item"><img src="/assets/images/BuildingIcon.svg" /> For Business</a></li>
              </ul>
            </li>
          `);
          
          $(document).off('click touchstart', '.mean-container .mean-nav ul li.dropdownlinks > a');
          $(document).on('click touchstart', '.mean-container .mean-nav ul li.dropdownlinks > a', (e) => {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
            const $li = $(e.currentTarget).closest('li');
            const $dropdown = $li.find('ul.dropdown-menu');
            $dropdown.toggleClass('show');
            $li.toggleClass('active');
            this.toggleMobileDropdown(e);
            
            return false;
          });
          
          $(document).off('click', '.mean-container .mean-nav .mobile-dropdown-item');
          $(document).on('click', '.mean-container .mean-nav .mobile-dropdown-item', (e) => {
            const action = $(e.currentTarget).data('action');
            this.closeMobileDropdown();
            
            if (action === 'postjob') {
              e.preventDefault();
              this.postJobRedirect(e);
            } else if (action === 'plans') {
              e.preventDefault();
              this.plansredirect(e);
            } else if (action === 'disputes') {
              e.preventDefault();
              this.disputesredirect(e);
            } else if (action === 'referrals') {
              e.preventDefault();
              this.referralsredirect(e);
            }
          });
        }
      }
    };
    
    if (window.jQuery) {
      const $ = window.jQuery;
      const setupMobileNav = () => {
        const screenWidth = window.innerWidth;
        if (screenWidth >= 320 && screenWidth <= 400) {
          try {
            if ($('.mean-menu').data('meanmenu')) {
              $('.mean-menu').meanmenu('destroy');
            }
          } catch(e) {}
          
          $('.mean-container').remove();
          $('.mean-bar').remove();
          $('.mean-push').remove();
          
          const $navCollapse = $('.mobile-nav-direct');
          if ($navCollapse.length) {
            $navCollapse.removeClass('collapse collapsing');
            $navCollapse.addClass('show');
            $navCollapse.css({
              'display': 'flex !important',
              'visibility': 'visible !important',
              'opacity': '1 !important',
              'height': 'auto !important',
              'overflow': 'visible !important'
            });
            
            $navCollapse.find('.navbar-nav').css({
              'display': 'flex !important',
              'visibility': 'visible !important'
            });
            
            $navCollapse.find('.nav-item').css({
              'display': 'block !important',
              'visibility': 'visible !important'
            });
          }
        }
      };
      
      const originalMeanMenu = $.fn.meanmenu;
      $.fn.meanmenu = function(options) {
        const screenWidth = window.innerWidth;
        if (screenWidth >= 320 && screenWidth <= 400) {
          return this;
        }
        return originalMeanMenu.call(this, options);
      };
      
      setupMobileNav();
      $(window).on('resize', () => {
        setupMobileNav();
        setTimeout(setupMobileDropdown, 300);
      });
      
      setTimeout(setupMobileNav, 100);
      setTimeout(setupMobileNav, 500);
      setTimeout(setupMobileNav, 1000);
    }
      
    setTimeout(setupMobileDropdown, 500);
    setTimeout(setupMobileDropdown, 1000);
    setTimeout(setupMobileDropdown, 2000);
    setTimeout(setupMobileDropdown, 3000);
    
    if (window.jQuery) {
      window.jQuery(window).on('resize', () => {
        setTimeout(setupMobileDropdown, 300);
      });
    }
    
    if (window.MutationObserver) {
      const observer = new MutationObserver(() => {
        const screenWidth = window.innerWidth;
        if (screenWidth <= 767 && !(screenWidth >= 320 && screenWidth <= 400)) {
          setupMobileDropdown();
        }
      });
      
      setTimeout(() => {
        const meanNav = document.querySelector('.mean-container .mean-nav');
        if (meanNav) {
          observer.observe(meanNav, { childList: true, subtree: true });
        }
      }, 1000);
    }
  }

  success = async (pos) => {
  }

  errors = (err) => {
  }

  getCurrentlocation = () => {
    if (navigator.permissions && navigator.permissions.query) {
      if (navigator.geolocation) {
        navigator.permissions
          .query({ name: "geolocation" })
          .then(this.getlatlang).catch(err => console.error("error: " + err));
      } else {
        alert("Sorry Not available!");
      }
    } else if (navigator.geolocation) {
      this.getlatlang();
    }
  };

  getlatlang = () => {
    const self = this;
    self.setState({ isGettingLocation: true });
    
    navigator.geolocation.getCurrentPosition(function (position) {
      const coords = position.coords;
      
      const calculateDistance = (lat1, lng1, lat2, lng2) => {
        const R = 6371000; // Earth's radius in meters
        const dLat = (lat2 - lat1) * Math.PI / 180;
        const dLng = (lng2 - lng1) * Math.PI / 180;
        const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
                  Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
                  Math.sin(dLng/2) * Math.sin(dLng/2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
        return R * c;
      };
      
      Geocode.setApiKey(process.env.REACT_APP_GOOGLE_LOCATION_API_KEY);
      Geocode.setLanguage("en");
      Geocode.setRegion("in");
      Geocode.setLocationType("ROOFTOP");
      Geocode.enableDebug();
      
      Geocode.fromLatLng(coords.latitude, coords.longitude).then(
        (response) => {
          self.setState({ isGettingLocation: false });
          if (response.results && response.results.length > 0) {
            let mostPreciseResult = null;
            let minDistanceForPrecise = Infinity;
            
            response.results.forEach((result) => {
              const resultTypes = result.types || [];
              const isPreciseType = resultTypes.includes('street_address') || 
                                   resultTypes.includes('premise') ||
                                   resultTypes.includes('subpremise');
              
              if (isPreciseType) {
                const resultLat = result.geometry?.location?.lat;
                const resultLng = result.geometry?.location?.lng;
                
                if (resultLat && resultLng) {
                  const distance = calculateDistance(
                    coords.latitude, 
                    coords.longitude, 
                    resultLat, 
                    resultLng
                  );
                  
                  if (distance < minDistanceForPrecise) {
                    minDistanceForPrecise = distance;
                    mostPreciseResult = result;
                  }
                }
              }
            });
            
            if (mostPreciseResult) {
              const fullAddress = mostPreciseResult.formatted_address;
              self.setlocation(fullAddress);
            } else {
              let closestResult = response.results[0];
              let minDistance = Infinity;
              
              response.results.forEach((result) => {
                const resultLat = result.geometry?.location?.lat;
                const resultLng = result.geometry?.location?.lng;
                
                if (resultLat && resultLng) {
                  const distance = calculateDistance(
                    coords.latitude, 
                    coords.longitude, 
                    resultLat, 
                    resultLng
                  );
                  
                  if (distance < minDistance) {
                    minDistance = distance;
                    closestResult = result;
                  }
                }
              });
              
              const fullAddress = closestResult.formatted_address;
              self.setlocation(fullAddress);
            }
            
          } else {
            toast.error("No address found for this location. Please try again.", {
              position: "top-right",
              autoClose: 3000,
            });
          }
        },
        (error) => {
          self.setState({ isGettingLocation: false });
          toast.error("Failed to get location. Please try again.", {
            position: "top-right",
            autoClose: 3000,
          });
        }
      );
    }, (e) => {
      self.setState({ isGettingLocation: false });
      let errorMessage = "Location access denied. Please enter location manually.";
      
      if (e.code === e.TIMEOUT) {
        errorMessage = "Location request timed out. Please try again or enter location manually.";
      } else if (e.code === e.POSITION_UNAVAILABLE) {
        errorMessage = "Location information unavailable. Please enter location manually.";
      } else if (e.code === e.PERMISSION_DENIED) {
        errorMessage = "Location access denied. Please enable location permissions or enter location manually.";
      }
      
      toast.error(errorMessage, {
        position: "top-right",
        autoClose: 4000,
      });
    }, {
      enableHighAccuracy: true,
      timeout: 10000,
      maximumAge: 0
    });
  }

  setlocation = (address) => {
    this.setState({
      fields: {...this.state.fields, location: address},
    }, () => {
      this.validateForm();
    });
  }

  checkOTPVerified = () => {
    if (window.localStorage.getItem("UserData") != "") {
      if (JSON.parse(window.localStorage.getItem("UserData")).verify_mobile != 1) {
        this.openMobileOTPModal();
      } else if (JSON.parse(window.localStorage.getItem("UserData")).verify_email != 1) {
        this.openEmailOTPModal();
      }
    }
  }

  responseGoogleSuccess = (response) => {
  };

  responseGoogleError = (response) => {
  };

  linkedInLogin = () => {
    const state = encodeURIComponent(Math.random().toString(36).substring(2));
    const linkedInAuthUrl = `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=${LINKEDIN_CLIENT_ID}&redirect_uri=${REDIRECT_URI}&scope=${SCOPE}&state=${state}`;
    
    this.currentLinkedInState = state;
    
    window.location.href = linkedInAuthUrl;
  };

  handleLinkedInLogin = async (code) => {
    try {
      this.setState({ isloginLoading: true });
      
      const formData = new URLSearchParams();
      formData.append("code", code);
      
      const response = await commonService.CommonService("linkedin/loginHandler", formData);
      
      if (response.status === 200 || response.status === "200") {
        if (response.is_first_time === "No") {
          toast.success(response.message, {
            position: "top-right",
            type: "success",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
          
          window.localStorage.setItem("UserData", JSON.stringify(response.data[0]));
          window.localStorage.setItem("email", response.data[0].email_id);
          window.localStorage.setItem("mobile", response.data[0].mobile_number || "");
          window.localStorage.setItem("auth_token", response.data[0].auth_token);
          window.localStorage.setItem("isLoggedIn", true);
          window.localStorage.setItem("categories_with_sub_categories", JSON.stringify(response.data[0].categories_with_sub_categories));
          
          this.closeLoginModal();
          this.closeRegisterModal();
          window.location.reload();
          
        } else {
          window.localStorage.setItem("UserData", JSON.stringify(response.data[0]));
          window.localStorage.setItem("auth_token", response.data[0].auth_token);
          this.closeLoginModal();
          this.closeRegisterModal();
          this.openSocialRegisterModal(
            response.data[0].first_name,
            response.data[0].last_name,
            response.data[0].email_id,
            "linkedin"
          );
        }
      } else {
        toast.error(response.message || 'LinkedIn authentication failed', {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      }
    } catch (error) {
      toast.error('LinkedIn authentication failed. Please try again.', {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
    } finally {
      this.setState({ isloginLoading: false });
    }
  };

  socialLogin = (firstname, lastname, email, type) => {
    this.setState((state) => ({ isloginLoading: true }));
    const FormData = require("form-data");
    const form = new FormData();
    form.append("first_name", firstname);
    form.append("last_name", lastname);
    form.append('mobile_number', "");
    form.append("email_id", email);
    form.append("type", type);

    commonService
      .CommonService("social_login", form)
      .then(async (res) => {
        if (res.status == 200) {
          if (res.is_first_time == "No") {
            toast.success(res.message, {
              position: "top-right",
              type: "success",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
            });
            window.localStorage.setItem("UserData", JSON.stringify(res.data[0]));
            window.localStorage.setItem("email", res.data[0].email_id);
            window.localStorage.setItem("mobile", res.data[0].mobile_number);

            window.localStorage.setItem("auth_token", res.data[0].auth_token);
            window.localStorage.setItem("isLoggedIn", true);
            window.localStorage.setItem("categories_with_sub_categories", JSON.stringify(res.data[0].categories_with_sub_categories));
            window.location.reload();

            this.closeLoginModal();
            this.closeRegisterModal();
          } else {
            window.localStorage.setItem("UserData", JSON.stringify(res.data[0]));
            window.localStorage.setItem("auth_token", res.data[0].auth_token);
            this.closeLoginModal();
            this.closeRegisterModal();
            this.openSocialRegisterModal(firstname, lastname, email, type);
          }
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.error(err.toString(), {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        this.setState((state) => ({ isloginLoading: false }));
      });
  };

  sendEmailOTP = () => {
    this.setState((state) => ({ isloginLoading: true }));
    const FormData = require("form-data");

    const form = new FormData();
    form.append("email_id", window.localStorage.getItem("email"));

    commonService
      .CommonService("send_otp_email", form)
      .then(async (res) => {
        if (res.status == 200) {
          toast.success(res.message, {
            position: "top-right",
            type: "success",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success(err.toString(), {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        this.setState((state) => ({ isloginLoading: false }));
      });
  };

  verifyEmailOTP = () => {
    this.setState((state) => ({ isloginLoading: true }));
    const FormData = require("form-data");

    const form = new FormData();
    form.append("email_id", window.localStorage.getItem("email"));
    form.append("otp", this.state.emailOTP);

    commonService
      .CommonService("verify_email", form)
      .then(async (res) => {
        if (res.status == 200) {
          toast.success(res.message, {
            position: "top-right",
            type: "success",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
          window.localStorage.setItem(
            "UserData",
            JSON.stringify(res.data[0])
          );
          this.closeEmailOTPModal();
          this.openSuccessModel();
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success(err.toString(), {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        this.setState((state) => ({ isloginLoading: false }));
      });
  };

  sendMobileOTP = () => {
    this.setState((state) => ({ isloginLoading: true }));
    const FormData = require("form-data");

    const form = new FormData();
    form.append("mobile_number", window.localStorage.getItem("mobile"));

    commonService
      .CommonService("send_otp_mobile", form)
      .then(async (res) => {
        if (res.status == 200) {
          toast.success(res.message, {
            position: "top-right",
            type: "success",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success(err.toString(), {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        this.setState((state) => ({ isloginLoading: false }));
      });
  };

  verifyMobileOTP = () => {
    this.setState((state) => ({ isloginLoading: true }));
    const FormData = require("form-data");

    const form = new FormData();
    form.append("mobile_number", window.localStorage.getItem("mobile"));
    form.append("otp", this.state.mobileOTP);

    commonService
      .CommonService("verify_mobile", form)
      .then(async (res) => {
        if (res.status == 200) {
          toast.success(res.message, {
            position: "top-right",
            type: "success",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
          window.localStorage.setItem(
            "UserData",
            JSON.stringify(res.data[0])
          );
          this.closeMobileOTPModal();
          this.openEmailOTPModal();
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success(err.toString(), {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        this.setState((state) => ({ isloginLoading: false }));
      });
  };

  login = (email, pass) => {
    this.setState((state) => ({ isloginLoading: true }));
    const form = new FormData();
    form.append("user_name", email);
    form.append("password", pass);
    
    userService
      .login(form)
      .then(async (res) => {
        if (res.status == 200) {
          if (res.data && res.data[0]) {
            window.localStorage.setItem("UserData", JSON.stringify(res.data[0]));
            window.localStorage.setItem("email", res.data[0].email_id);
            window.localStorage.setItem("mobile", res.data[0].mobile_number);
            window.localStorage.setItem("auth_token", res.data[0].auth_token);
            window.localStorage.setItem("isLoggedIn", true);
            window.localStorage.setItem("categories_with_sub_categories", JSON.stringify(res.data[0].categories_with_sub_categories));
            
            this.closeLoginModal();
            window.location.reload();
          } else {
            toast.error("Login failed: No user data received", {
              position: "top-right",
              autoClose: 5000,
            });
          }
        } else {
          const nameField = document.querySelector('input[name="name"]');
          const passwordField = document.querySelector('input[name="password"]');
          
          if (nameField) {
            nameField.style.border = '1px solid #dc3545';
            nameField.classList.add('validation-error');
            setTimeout(() => {
              nameField.style.removeProperty('border');
              nameField.classList.remove('validation-error');
            }, 3000);
          }
          
          if (passwordField) {
            passwordField.style.border = '1px solid #dc3545';
            passwordField.classList.add('validation-error');
            setTimeout(() => {
              passwordField.style.removeProperty('border');
              passwordField.classList.remove('validation-error');
            }, 3000);
          }
          
          toast.error(res.message || "Login failed", {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        const nameField = document.querySelector('input[name="name"]');
        const passwordField = document.querySelector('input[name="password"]');
        
        if (nameField) {
          nameField.style.border = '1px solid #dc3545';
          nameField.classList.add('validation-error');
          setTimeout(() => {
            nameField.style.removeProperty('border');
            nameField.classList.remove('validation-error');
          }, 3000);
        }
        
        if (passwordField) {
          passwordField.style.border = '1px solid #dc3545';
          passwordField.classList.add('validation-error');
          setTimeout(() => {
            passwordField.style.removeProperty('border');
            passwordField.classList.remove('validation-error');
          }, 3000);
        }
        
        toast.error(err.message || err.toString() || "Login failed due to network error", {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        this.setState((state) => ({ isloginLoading: false }));
      });
  };

  register = async (location, aadhar, formData = null) => {
    if (this.state.isregisterLoading) {
      return;
    }
    
    if (this.state.termsAccepted) {
      this.setState((state) => ({ isregisterLoading: true }));
      const looking_for = this.state.selectedLookingFor === "freelance,fulltime"
        ? "freelance,fulltime"
        : this.state.selectedLookingFor === "fulltime"
        ? "fulltime"
        : "freelance"; 
      const register_for = this.state.isCompany ? "company" : "individual";
      const FormData = require("form-data");
      const form = new FormData();
      
      const firstName = formData?.firstName || this.state.first_name;
      const lastName = formData?.lastName || this.state.last_name;
      const mobile = formData?.phone_number || this.state.mobile;
      const email = formData?.email || this.state.email;
      const password = formData?.password || this.state.password;
      const confirmPassword = formData?.confirmpassword || this.state.confirmpassword;
      
      form.append("first_name", firstName);
      form.append("last_name", lastName);
      form.append("mobile_number", mobile);
      form.append("email_id", email);
      form.append("register_for", register_for);
      form.append("looking_for[]", looking_for);
      form.append("location", location || "");
      if (this.state.isCompany) {
        form.append("company_name", aadhar || "");
      } else {
        form.append("aadhaar_number", aadhar || "");
      }
      form.append("password", this.state.isSocialRegister ? "" : password);
      form.append("confrm_password", this.state.isSocialRegister ? "" : confirmPassword);
      form.append("terms_accepted", this.state.termsAccepted ? "1" : "0");
      form.append("reffered_by", this.state.fields.referralCode.trim() || "");
      commonService
        .CommonService(this.state.isSocialRegister ? "social_register" : "user_register", form)
        .then(async (res) => {
          if (res.status == 200) {
            window.localStorage.setItem(
              "UserData",
              JSON.stringify(res.data[0])
            );
            window.localStorage.setItem("email", res.data[0].email_id);
            window.localStorage.setItem("mobile", res.data[0].mobile_number);
            window.localStorage.setItem("auth_token", res.data[0].auth_token);
            window.localStorage.setItem("isLoggedIn", true);
            window.localStorage.setItem("categories_with_sub_categories", JSON.stringify(res.data[0].categories_with_sub_categories));
            window.location.reload();
          } else {
            toast.error(res.message, {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: 0,
            });
          }
        })
        .catch((err) => {
          toast.error(err.toString(), {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        })
        .finally(() => {
          this.setState((state) => ({ isregisterLoading: false }));
        });
    } else {
      toast.error("Please accept the terms and conditions to continue", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
    }
  };

  forgotpassword = () => {
    const identifier = (this.state.forgotpass || '').toString().trim();
    
    if (!identifier) {
      toast.error("Please enter email or mobile number", {
        position: "top-right",
        autoClose: 5000,
      });
      return;
    }

    if (isForgotPassAPICallInProgress(identifier)) {
      toast.warning("Please wait, request is being processed...", {
        position: "top-right",
        autoClose: 2000,
      });
      return;
    }

    if (!isForgotPassBlocked(identifier) && isForgotPassOnCooldown(identifier)) {
      const remainingSeconds = getForgotPassCooldownRemainingTime(identifier);
      toast.warning(`Please wait ${remainingSeconds} seconds before requesting OTP again`, {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    if (isForgotPassBlocked(identifier)) {
      const remainingMinutes = getForgotPassRemainingTime(identifier);
      toast.error(`Too many attempts. Please try again after ${remainingMinutes} minutes`, {
        position: "top-right",
        autoClose: 5000,
      });
      return;
    }

    const currentAttempts = getForgotPassAttemptsCount(identifier);

    if (currentAttempts >= 3) {
      blockForgotPassUser(identifier);
      const remainingMinutes = getForgotPassRemainingTime(identifier);
      toast.error(`Too many attempts. Please try again after ${remainingMinutes} minutes`, {
        position: "top-right",
        autoClose: 5000,
      });
      return;
    }

    const newAttemptCount = currentAttempts + 1;
    setForgotPassAttemptsCount(identifier, newAttemptCount);

    if (newAttemptCount >= 3) {
      blockForgotPassUser(identifier);
    }

    setForgotPassAPICallLock(identifier);

    this.setState({ forgotPassIdentifier: identifier });


    this.setState({ isloginLoading: true });
    const form = new FormData();
    form.append("user_name", identifier);

    commonService
      .CommonService("forgot_password", form)
      .then(async (res) => {
        
        if (res.status == 200) {
          
          if (newAttemptCount < 3) {
            setForgotPassCooldown(identifier);
          }
          
          this.setState({ 
            resetPassIsOpen: true,
            forgotPassIsOpen: false 
          });
          
          toast.success(res.message, {
            position: "top-right",
            autoClose: 5000,
          });
        } else {
          
          if (newAttemptCount >= 3) {
            const remainingMinutes = getForgotPassRemainingTime(identifier);
            toast.error(`Too many failed attempts. Please try again after ${remainingMinutes} minutes`, {
              position: "top-right",
              autoClose: 5000,
            });
          } else {
            toast.error(res.message || "Failed to send OTP", {
              position: "top-right",
              autoClose: 5000,
            });
          }
        }
      })
      .catch((err) => {
        
        if (newAttemptCount >= 3) {
          const remainingMinutes = getForgotPassRemainingTime(identifier);
          toast.error(`Too many failed attempts. Please try again after ${remainingMinutes} minutes`, {
            position: "top-right",
            autoClose: 5000,
          });
        } else {
          toast.error(err.toString() || "Something went wrong", {
            position: "top-right",
            autoClose: 5000,
          });
        }
      })
      .finally(() => {
        removeForgotPassAPICallLock(identifier);
        this.setState({ isloginLoading: false });
      });
  };

  resetpassword = () => {
    const newPassword = this.state.newPass || '';
    const confirmPassword = this.state.confirmNewpass || '';
    
    if (!newPassword || newPassword.length === 0) {
      toast.error("Please enter a new password", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    
    const hasMinLength = newPassword.length >= 8;
    const hasUpperCase = /[A-Z]/.test(newPassword);
    const hasNumber = /[0-9]/.test(newPassword);
    const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(newPassword);
    
    if (!hasMinLength) {
      toast.error("Password must be at least 8 characters", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    
    if (!hasUpperCase) {
      toast.error("Password must contain at least 1 uppercase letter", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    
    if (!hasNumber) {
      toast.error("Password must contain at least 1 number", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    
    if (!hasSpecialChar) {
      toast.error("Password must contain at least 1 special character", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    
    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    
    this.setState((state) => ({ isloginLoading: true }));
    const FormData = require("form-data");

    const form = new FormData();
    form.append('user_name', this.state.forgotpass);
    form.append('otp', this.state.otp);
    form.append('password', this.state.newPass);
    form.append('confirm_password', this.state.confirmNewpass);

    commonService
      .CommonService("reset_password", form)
      .then(async (res) => {
        if (res.status == 200) {
          toast.success(res.message, {
            position: "top-right",
            type: "success",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        
          this.closeResetPassModal();
        } else {
          toast.success(res.message, {
            position: "top-right",
            type: "error",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: 0,
          });
        }
      })
      .catch((err) => {
        toast.success(err.toString(), {
          position: "top-right",
          type: "error",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: 0,
        });
      })
      .finally(() => {
        this.closeResetPassModal();
        this.setState((state) => ({ isloginLoading: false }));
      });
  };

  redirect = (e) => {
    e.preventDefault()
    this.closeSuccessModal();
    this.closeRegisterModal();
    this.closeRegisterTwoModal();
    this.props.history.push("/profileEdit");
  };

  homeclick = (e) => {
    e.preventDefault()
    this.props.history.push("/");
  };

  isActiveRoute = (path) => {
    const currentPath = this.props.location.pathname;
    return currentPath === path;
  };

  profileredirect = (e) => {
    e.preventDefault()
    this.props.history.push("/profile");
  };

  disputesredirect = (e) => {
    e.preventDefault()
    this.props.history.push("/disputes");
  };

  referralsredirect = (e) => {
    e.preventDefault()
    this.props.history.push("/referral");
  };

  plansredirect = (e) => {
    e.preventDefault()
    this.props.history.push("/plans");
  };

  postJobRedirect = (e) => {
    e.preventDefault()
    this.props.history.push("/postjob");
  };

  toggleMobileDropdown = (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    this.setState((prevState) => ({
      mobileDropdownOpen: !prevState.mobileDropdownOpen
    }));
  };

  closeMobileDropdown = () => {
    this.setState({ mobileDropdownOpen: false });
  };

  businessredirect = (e) => {
    e.preventDefault()
    this.props.history.push("/business");
  };

  myquotesRedirect = (e) => {
    e.preventDefault()
    this.props.history.push("/myjobs");
  };

  myContractRedirect = (e) => {
    e.preventDefault()
    this.props.history.push("/mycontracts");
  };

  // Opens the registration modal
  openRegisterModal = () => {
    this.setState((state) => ({ registerModelIsOpen: true, isLogin: false }), () => {
      this.setValidationRules();
    });
    document.body.style.overflow = "hidden";
  };

  closeRegisterModal = () => {
    this.setState((state) => ({ registerModelIsOpen: false }));
    document.body.style.overflow = "unset";
  };

  openSuccessModel = () => {
    this.setState((state) => ({ successPopupOpen: true }));
    document.body.style.overflow = "hidden";
  };

  closeSuccessModal = () => {
    this.setState((state) => ({ successPopupOpen: false }));
    document.body.style.overflow = "unset";
  };

  openTermsModel = () => {
    this.setState((state) => ({ termsPopupIsOpen: true }));
    document.body.style.overflow = "hidden";
  };

  closeTermsModal = () => {
    this.setState((state) => ({ termsPopupIsOpen: false }));
    document.body.style.overflow = "unset";
  };

  openPrivacyModal = () => {
    this.setState((state) => ({ privacyPopupIsOpen: true }));
    document.body.style.overflow = "hidden";
  };

  closePrivacyModal = () => {
    this.setState((state) => ({ privacyPopupIsOpen: false }));
    document.body.style.overflow = "unset";
  };

  openRegisterTwoModal = () => {
    this.setState((state) => ({
      registerTwoModelIsOpen: true,
      isLogin: false,
      isRegisterTwo: true,
    }), () => {
      this.setValidationRules();
    });
    document.body.style.overflow = "hidden";
  };

  closeRegisterTwoModal = () => {
    this.setState((state) => ({
      registerTwoModelIsOpen: false,
      isRegisterTwo: false,
      fields: {
        ...state.fields,
        firstName: state.first_name,
        lastName: state.last_name,
        email: state.email,
        phone_number: state.mobile,
        password: state.password,
        confirmpassword: state.confirmpassword,
        location: state.fields.location,
        referralCode: state.fields.referralCode,
      }
    }), () => {
      this.setState({
        registerModelIsOpen: true,
        isLogin: false
      }, () => {
        this.setValidationRules();
        this.validateForm();
      });
    });
    document.body.style.overflow = "unset";
  };

  showIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
      <circle cx="12" cy="12" r="3"></circle>
    </svg>
  );

  hideIcon = () => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
      <line x1="1" y1="1" x2="23" y2="23"></line>
    </svg>
  )

  // Opens the login modal
  openLoginModal = () => {
    this.setState((state) => ({ loginModelIsOpen: true, isLogin: true }), () => {
      this.setValidationRules();
      this.validateLoginForm();
    });
    document.body.style.overflow = "hidden";
  };

  closeLoginModal = () => {
    this.setState((state) => ({ loginModelIsOpen: false }));
    document.body.style.overflow = "unset";
  };

  openMobileOTPModal = () => {
    this.setState((state) => ({ mobileOTPPopupIsOpen: true, isLogin: true }));
    document.body.style.overflow = "hidden";
  };

  closeMobileOTPModal = () => {
    this.setState((state) => ({ mobileOTPPopupIsOpen: false }));
    document.body.style.overflow = "unset";
  };

  openEmailOTPModal = () => {
    this.setState((state) => ({ emailOTPPopupIsOpen: true, isLogin: true }));
    document.body.style.overflow = "hidden";
  };

  closeEmailOTPModal = () => {
    this.setState((state) => ({ emailOTPPopupIsOpen: false }));
    document.body.style.overflow = "unset";
  };

  openSocialRegisterModal = (fname, lname, email, type) => {
    this.setState((state) => ({ socialRegisterIsOpen: true, first_name: fname, last_name: lname, email, type }));
    document.body.style.overflow = "hidden";
  };

  closeSocialRegisterModal = () => {
    this.setState((state) => ({ socialRegisterIsOpen: false }));
    document.body.style.overflow = "unset";
  };

  openForgotPassModal = () => {
    this.setState({ forgotpass: this.state.fields.name }, () => {
      this.validateForgotPasswordForm();
    });
    this.setState((state) => ({ forgotPassIsOpen: true }));
    document.body.style.overflow = "hidden";
  };

  closeForgotPassModal = () => {
    this.setState((state) => ({ forgotPassIsOpen: false }));
    document.body.style.overflow = "unset";
  };

  openResetPassModal = () => {
    this.setState((state) => ({ resetPassIsOpen: true }));
    document.body.style.overflow = "hidden";
  };

  closeResetPassModal = () => {
    this.setState((state) => ({ resetPassIsOpen: false }));
    document.body.style.overflow = "unset";
  };

  logout = (e) => {
    e.preventDefault();
    googleLogout();
    StorageHelper.clearAuthDataOnly();
    this.props.history.push("/");
    window.location.reload();
  };

  onCompanyClick = () => {
    this.setState((state) => ({ isCompany: true }));
  };

  onIndividualClick = () => {
    this.setState((state) => ({ isCompany: false }));
  };

  onProjectClick = () => {
    this.setState({ selectedLookingFor: "freelance" });
  };

  onServiceClick = () => {
    this.setState({ selectedLookingFor: "fulltime" });
  };

  onBothClick = () => {
    this.setState({ selectedLookingFor: "freelance,fulltime" });
  };

  handleIsBoth = () => {
    this.setState((state) => ({ isBoth: !this.state.isBoth }));
  };

  handleStep2Submit = () => {
    if (!this.state.fields.location) {
      toast.error("Please enter your location", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    
    if (!this.state.termsAccepted) {
      toast.error("Please accept the terms and conditions to continue", {
        position: "top-right",
        type: "error",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: 0,
      });
      return;
    }
    
    const formData = {
      firstName: this.state.first_name,
      lastName: this.state.last_name,
      email: this.state.email,
      phone_number: this.state.mobile,
      password: this.state.password,
      confirmpassword: this.state.confirmpassword,
      location: this.state.fields.location,
      aadhar: ""
    };
    
    this.register(this.state.fields.location, "", formData);
  };

  handleEmailInput = (event) => {
    this.setState({
      email: event.target.value,
    });
  };

  handlePasswordInput = (event) => {
    this.setState({
      password: event.target.value,
    });
  };

  render() {
    return (
      <div>
        <style dangerouslySetInnerHTML={{
          __html: `
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `
        }} />
        <div className={this.state.isLoggedIn == true ? "navbar-area" : "navbar-area before-login"}>
          <div className="main-responsive-nav">
            <div className="container">
              <nav className={`navbar navbar-expand-md navbar-light ${this.state.isLoggedIn != true && 'logged-out-navbar'}`}>
                <a className="navbar-brand" href="#" onClick={this.homeclick}>
                  <img src="/assets/images/FWSGIG_NEWLOGO.svg" alt="logo"  style={{ width: '80px', height: 'auto' }} />
                </a>
                <div
                  className="navbar-collapse mean-menu mobile-nav-direct"
                  id="navbarSupportedContent"
                >
                  {this.state.isLoggedIn == true ? (
                    <ul className="navbar-nav m-auto">
                      {/* <li className="nav-item">
                        <a
                          href={baseLink + "/"}
                          className={`nav-link active ${this.isActiveRoute('/') ? 'currentRoute' : ''}`}
                        >
                          Explore Jobs
                        </a>
                      </li> */}
                      {/* <li className="nav-item mobile-hide">
                        <a
                          href="#"
                          className={`nav-link active ${this.isActiveRoute('/postjob') ? 'currentRoute' : ''}`}
                          onClick={this.postJobRedirect}
                        >
                          Post a Job
                        </a>
                      </li>
                      <li className="nav-item mobile-hide">
                        <a
                          href="#"
                          className={`nav-link active ${this.isActiveRoute('/plans') ? 'currentRoute' : ''}`}
                          onClick={this.plansredirect}
                        >
                          Plans
                        </a>
                      </li> */}
                      <li className={`nav-item dropdownlinks ${this.state.mobileDropdownOpen ? 'active' : ''}`}>
                        <a 
                          href="#" 
                          className="nav-link active"
                          onClick={this.toggleMobileDropdown}
                        >
                          More
                          <i className="bx bx-chevron-down" />
                        </a>
                        <ul className={`dropdown-menu ${this.state.mobileDropdownOpen ? 'show' : ''}`}>
                          <li className="nav-item">
                        <a
                          href={baseLink + "/"}
                          className={`nav-link active ${this.isActiveRoute('/') ? 'currentRoute' : ''}`}
                        >
                          Explore Jobs
                        </a>
                      </li> 
                          <li className="dd-horizontal mobile-show">
                            <a
                              href="#"
                              className={`nav-link active ${this.isActiveRoute('/postjob') ? 'currentRoute' : ''}`}
                              onClick={(e) => {
                                e.preventDefault();
                                this.closeMobileDropdown();
                                this.postJobRedirect(e);
                              }}
                            >
                              Post a Job
                            </a>
                          </li>
                          <li className="dd-horizontal mobile-show">
                            <a
                              href="#"
                              className={`nav-link active ${this.isActiveRoute('/plans') ? 'currentRoute' : ''}`}
                              onClick={(e) => {
                                e.preventDefault();
                                this.closeMobileDropdown();
                                this.plansredirect(e);
                              }}
                            >
                              Plans
                            </a>
                          </li>
                          <li className="dd-horizontal">
                            <a
                              href={baseLink + "/myjobs"}
                              className={`nav-link active ${this.isActiveRoute('/myjobs') ? 'currentRoute' : ''}`}
                              onClick={this.closeMobileDropdown}
                            >
                              My Jobs
                            </a>
                          </li>
                          <li className="dd-horizontal">
                            <a
                              href={baseLink + "/mycontracts"}
                              className={`nav-link active ${this.isActiveRoute('/mycontracts') ? 'currentRoute' : ''}`}
                              onClick={this.closeMobileDropdown}
                            >
                              Jobs I Posted
                            </a>
                          </li>
                          <li className="dd-horizontal">
                            <a
                              href={baseLink + "/payment"}
                              className="nav-link active"
                              onClick={this.closeMobileDropdown}
                            >
                              
                              Payment
                            </a>
                          </li>
                          <li className="dd-horizontal">
                            <a
                              href="#"
                              className="nav-link active"
                              onClick={(e) => {
                                e.preventDefault();
                                this.closeMobileDropdown();
                                this.disputesredirect(e);
                              }}
                            >
                              
                              Disputes
                            </a>
                          </li>
                          <li className="dd-horizontal">
                            <a
                              href="#"
                              className="nav-link active"
                              onClick={(e) => {
                                e.preventDefault();
                                this.closeMobileDropdown();
                                this.referralsredirect(e);
                              }}
                            >
                              
                              Referrals
                            </a>
                          </li>
                          <li className="dd-horizontal">
                            <a
                              href={baseLink + "/business"}
                              className={`nav-link active `}
                              onClick={this.closeMobileDropdown}
                            >
                              
                              For Business
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>) : (
                    <ul className="navbar-nav m-auto">
                    </ul>)}
                  <div className="others-options d-flex align-items-center">
                    {this.state.isLoggedIn == false ? (
                      <div className="option-item">
                        <div className="navbar-btn">
                          <Link
                            to="#"
                            onClick={this.openRegisterModal}
                            className="default-btn secondary-btn register-btn"
                          >
                            Register
                          </Link>
                          <Link
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              this.openLoginModal();
                            }}
                            className="default-btn login-btn"
                          >
                            Login
                          </Link>
                        </div>
                      </div>
                    ) : (
                      <div className="option-item">
                        <div className="navbar-btn">
                          <NavigationBtn />
                          <a href={baseLink + "/profile"}>
                            {(() => {
                              const userData = JSON.parse(localStorage.getItem("UserData") || "null");
                              const image = userData && userData.profile_image ? (userData.profile_image.includes("https://") ? userData.profile_image : `${process.env.REACT_APP_BACKEND_BASE_URL}/${userData.profile_image}`) : "/assets/images/profile-circle.svg";
                              return userData && userData.profile_image ? (
                                <img
                                  src={image}
                                  alt="Profile"
                                  className={`profile-image ${this.isActiveRoute('/profile') && 'active'}`}
                                />
                              ) : (
                                <img
                                  src={image}
                                  alt="Profile"
                                />
                              );
                            })()}
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </nav>
            </div>
          </div>
          <div className="main-navbar">
            <div className="container">
              <nav className={`navbar navbar-expand-md navbar-light ${this.state.isLoggedIn != true && 'logged-out-navbar'}`}>
                <a className="navbar-brand" href="#" onClick={this.homeclick}>
                  <img src="/assets/images/FWSGIG_NEWLOGO.svg" alt="logo"  style={{ width: '80px', height: 'auto' }} />
                </a>
                <div
                  className="collapse navbar-collapse mean-menu"
                  id="navbarSupportedContent"
                >
                  {this.state.isLoggedIn == true ? (
                    <ul className="navbar-nav m-auto">
                      <li className="nav-item">
                        <a
                          href={baseLink + "/"}
                          className={`nav-link active ${this.isActiveRoute('/') ? 'currentRoute' : ''}`}
                        >
                          Explore Jobs
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          href={baseLink + "/myjobs"}
                          className={`nav-link active ${this.isActiveRoute('/myjobs') ? 'currentRoute' : ''}`}
                        >
                          My Jobs
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          href={baseLink + "/mycontracts"}
                          className={`nav-link active ${this.isActiveRoute('/mycontracts') ? 'currentRoute' : ''}`}
                        >
                          Jobs I Posted
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          href="#"
                          className={`nav-link active ${this.isActiveRoute('/plans') ? 'currentRoute' : ''}`}
                          onClick={this.plansredirect}
                        >
                          Plans
                        </a>
                      </li>
                      <li className="nav-item">
                        <a
                          href="#"
                          className={`nav-link active ${this.isActiveRoute('/postjob') ? 'currentRoute' : ''}`}
                          onClick={this.postJobRedirect}
                        >
                          Post a Job
                        </a>
                      </li>
                      <li className="nav-item dropdownlinks">
                        <a href="#" className="nav-link active">
                          More
                          <i className="bx bx-chevron-down" />
                        </a>
                        <ul className="dropdown-menu  ">
                          <li className="dd-horizontal">
                            <a
                              href={baseLink + "/payment"}
                              className="nav-link active"
                            >
                              <img src="/assets/images/PaymentsIcon.svg" />
                              Payment
                            </a>
                          </li>
                          <li className="dd-horizontal">
                            <a
                              href="#"
                              className="nav-link active"
                              onClick={this.disputesredirect}
                            >
                              <img src="/assets/images/DisputesIcon.svg" />
                              Disputes
                            </a>
                          </li>
                          <li className="dd-horizontal">
                            <a
                              href="#"
                              className="nav-link active"
                              onClick={this.referralsredirect}
                            >
                              <img src="/assets/images/ReferralsIcon.svg" />
                              Referrals
                            </a>
                          </li>
                          <li className="dd-horizontal">
                            <a
                              href={baseLink + "/business"}
                              className={`nav-link active `}
                            >
                              <img src="/assets/images/BuildingIcon.svg" />
                              For Business
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>) : (
                    <ul className="navbar-nav m-auto">
                    </ul>)}
                  <div className="others-options d-flex align-items-center">
                    {this.state.isLoggedIn == false ? (
                      <div className="option-item">
                        <div className="navbar-btn">
                          <Link
                            to="#"
                            onClick={this.openRegisterModal}
                            className="default-btn secondary-btn register-btn"
                          >
                            Register
                          </Link>
                          <Link
                            to="#"
                            onClick={(e) => {
                              e.preventDefault();
                              this.openLoginModal();
                            }}
                            className="default-btn login-btn"
                          >
                            Login
                          </Link>
                        </div>
                      </div>
                    ) : (
                      <div className="option-item">
                        <div className="navbar-btn">
                          <NavigationBtn />
                          <a href={baseLink + "/profile"}>
                            {(() => {
                              const userData = JSON.parse(localStorage.getItem("UserData") || "null");
                              const image = userData && userData.profile_image ? (userData.profile_image.includes("https://") ? userData.profile_image : `${process.env.REACT_APP_BACKEND_BASE_URL}/${userData.profile_image}`) : "/assets/images/profile-circle.svg";
                              return userData && userData.profile_image ? (
                                <img
                                  src={image}
                                  alt="Profile"
                                  className={`profile-image ${this.isActiveRoute('/profile') && 'active'}`}
                                />
                              ) : (
                                <img
                                  src={image}
                                  alt="Profile"
                                />
                              );
                            })()}
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </nav>
            </div>
          </div>
         
        </div>
        <Modal
          isOpen={this.state.registerModelIsOpen}
          onRequestClose={() => {
            this.closeRegisterModal();
            document.body.classList.remove('modal-open');
          }}
          onAfterOpen={() => {
            document.body.classList.add('modal-open');
          }}
          style={loginModalStyles}
          contentLabel="Registration Modal"
          scrollable={true}
        >
          <LoadingOverlay>
            <div className="register-modal">
              <div className="register-modal-header">
                <h5 className="register-modal-title">GigFWS Group</h5>
                <button
                  type="button"
                  className="register-close-btn"
                  onClick={() => {
                    this.closeRegisterModal();
                    document.body.classList.remove('modal-open');
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="register-modal-body">
                <h2 className="welcome-text">Join GigFWS Group!</h2>
                <p className="instruction-text" style={{ color: '#f57e1f' }}>Create your account to get started</p>
                
                <form onSubmit={this.form.handleSubmit}>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="First Name (Min. 1 and Max. 30 characters)"
                      name="firstName"
                      onBlur={this.form.handleBlurEvent}
                      onChange={this.handleFieldChange}
                      onKeyDown={this.preventNumeric}
                      value={this.state.fields.firstName}
                      maxLength="30"
                    />
                    <label className="error">
                      {this.state.errors && this.state.errors.firstName ? this.state.errors.firstName : ""}
                    </label>
                  </div>
                  
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Last Name (Min. 1 and Max. 30 characters)"
                      name="lastName"
                      onBlur={this.form.handleBlurEvent}
                      onChange={this.handleFieldChange}
                      onKeyDown={this.preventNumeric}
                      value={this.state.fields.lastName}
                      maxLength="30"
                    />
                    <label className="error">
                      {this.state.errors && this.state.errors.lastName ? this.state.errors.lastName : ""}
                    </label>
                  </div>
                  
                  <div className="form-group">
                    <input
                      type="email"
                      className="form-control"
                      placeholder="Email ID"
                      name="email"
                      onBlur={this.form.handleBlurEvent}
                      onChange={this.handleFieldChange}
                      value={this.state.fields.email}
                    />
                    <label className="error">
                      {this.state.errors && this.state.errors.email ? this.state.errors.email : ""}
                    </label>
                  </div>
                  
                  <div className="form-group">
                    <input
                      type="tel"
                      className="form-control"
                      placeholder="Mobile Number (10 digits)"
                      name="phone_number"
                      inputMode="numeric"
                      pattern="[6-9]\\d{9}"
                      title="Enter a valid 10-digit Indian mobile number"
                      maxLength="10"
                      onBlur={this.form.handleBlurEvent}
                      onChange={(e) => {
                        const value = e.target.value.replace(/\D/g, '').slice(0, 10);
                        const syntheticEvent = {
                          ...e,
                          target: {
                            ...e.target,
                            value: value,
                            name: 'phone_number'
                          }
                        };
                        this.handleFieldChange(syntheticEvent);
                      }}
                      value={this.state.fields.phone_number}
                    />
                    <label className="error">
                      {this.state.errors && this.state.errors.phone_number ? this.state.errors.phone_number : ""}
                    </label>
                  </div>
                  
                  <div className="form-group password-sec">
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Password (8 chars, 1 uppercase, 1 number, 1 special)"
                      name="password"
                      onBlur={this.form.handleBlurEvent}
                      onChange={this.handleFieldChange}
                      value={this.state.fields.password}
                      ref={this.inputRef1}
                    />
                    <ReactPasswordToggleIcon 
                      inputRef={this.inputRef1} 
                      showIcon={this.hideIcon}
                      hideIcon={this.showIcon}
                    />
                    <label className="error">
                      {this.state.errors && this.state.errors.password ? this.state.errors.password : ""}
                    </label>
                  </div>
                  
                  <div className="form-group con-password-sec">
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Confirm Password"
                      name="confirmpassword"
                      onBlur={this.form.handleBlurEvent}
                      onChange={this.handleFieldChange}
                      value={this.state.fields.confirmpassword}
                      ref={this.inputRef}
                    />
                    <ReactPasswordToggleIcon 
                      inputRef={this.inputRef} 
                      showIcon={this.hideIcon}
                      hideIcon={this.showIcon}
                    />
                    <label className="error">
                      {this.state.errors && this.state.errors.confirmpassword ? this.state.errors.confirmpassword : ""}
                    </label>
                  </div>
                </form>
                
                <div className="register-modal-footer">

                  <button 
                    type="button" 
                    className={`btn btn-default ${!this.state.isFormValid ? 'btn-disabled' : ''}`}
                    onClick={(e) => {
                      if (!this.state.isFormValid) {
                        e.preventDefault();
                        this.scrollToFirstEmptyField();
                        toast.error("Please fill in all required fields", {
                          position: "top-right",
                          autoClose: 3000,
                        });
                      } else {
                        this.form.handleSubmit(e);
                      }
                    }}
                  >
                    CONTINUE
                  </button>
                  
                  <div className="social-login-section">
                    <div className="horizontal-line">
                      <span>Sign up with</span>
                    </div>
                    <ul className="social-login" style={{ display: 'flex', alignItems: 'center', listStyle: 'none', padding: 0, margin: 0 }}>
                      {/* <li>
                        <FacebookLogin
                          appId="550051726058276"
                          autoLoad={false}
                          fields="name,email,picture"
                          callback={this.responseFacebook}
                          render={renderProps => (
                            <a href="#" onClick={renderProps.onClick}>
                              <img src={facebookImage} alt="Facebook" />
                            </a>
                          )}
                        />
                      </li> */}
                      <li>
                        <a href="#" onClick={e => { e.preventDefault(); this.linkedInLogin(); }}>
                          <img src={linkedinImage} alt="LinkedIn" />
                        </a>
                      </li>
                      <li>
                        <div style={{ position: 'relative', display: 'inline-block', width: '33px', height: '33px' }}>
                          <img 
                            src={googleImage} 
                            alt="Google" 
                            style={{ 
                              position: 'absolute',
                              top: '3px',
                              left: '0',
                              transition: 'all 0.2s ease',
                              zIndex: 1,
                              height: '33px',
                              width: '33px',
                            }}
                          />
                          <div style={{ 
                            position: 'absolute',
                            top: '3px',
                            left: '0',
                            width: '33px',
                            height: '33px',
                            zIndex: 2,
                            opacity: 0.001,
                            cursor: 'pointer'
                          }}>
                            <GoogleLogin
                              data-testid="google-login-button"
                              size="large"
                              type="icon"
                              theme="outline"
                              shape="circle"
                              onSuccess={credentialResponse => {
                                const realUserData = getDecodedOAuthJwtGoogle(credentialResponse.credential)
                                realUserData.then(result => {
                                  var index = result.getPayload().name.indexOf(' ');
                                  var firstname = result.getPayload().name.substr(0, index);
                                  var lastname = result.getPayload().name.substr(index+1);
                                  this.socialLogin(firstname,lastname,result.getPayload().email,"gmail_login")
                                }).catch(err => err)
                              }}
                              onError={() => {}}
                            />
                          </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            <Loader loading={this.state.isRegisterLoading} />
          </LoadingOverlay>
        </Modal>
        <Modal
          isOpen={this.state.registerTwoModelIsOpen}
          onRequestClose={this.closeRegisterTwoModal}
          style={customStyles}
          contentLabel="Example Modal"
          scrollable={true}
        >
          <LoadingOverlay>
            <div className="register-modal">
              <div className="register-modal-header">
                <h5 className="register-modal-title">GigFWS Group</h5>
                <button
                  type="button"
                  className="register-close-btn"
                  onClick={this.closeRegisterTwoModal}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="register-two-modal-body">
                <h2 className="welcome-text">Join GigFWS Group!</h2>
                <p className="instruction-text" style={{ color: '#f57e1f' }}>Complete your profile to get started</p>
                
                <form onSubmit={this.form.handleSubmit}>
                  <div className="form-group">
                    <LocationAutocomplete
                      value={this.state.fields.location}
                      onChange={(value) => {
                        this.setState({
                          fields: {...this.state.fields, location: value},
                        }, () => {
                          this.validateForm();
                        });
                      }}
                      onPlaceSelected={(address, place) => {
                        this.form.handleBlurEvent({ target: { name: 'location', value: address } });
                      }}
                      placeholder="Enter Location"
                      locationType="header"
                      className="form-control"
                    />
                    <label className="error">
                      {" "}
                      {this.state.errors && this.state.errors.location
                        ? this.state.errors.location
                        : ""}
                    </label>
                  </div>
                  <div className="tab-section">
                    <div className="tab services-list-tab">
                      <p className="tab-title">I am</p>
                      <ul className="tabs">
                        <li>
                          <Link
                            to="#"
                            style={{
                              borderColor:
                                this.state.isCompany === false
                                  ? "#F85100"
                                  : "transparent",
                            }}
                            onClick={this.onIndividualClick}
                          >
                            <span>
                              <img src="/assets/images/user.png" />{" "}
                              Individual
                            </span>
                          </Link>
                        </li>
                        <li>
                          <Link
                            to="#"
                            style={{
                              borderColor:
                                this.state.isCompany === true
                                  ? "#F85100"
                                  : "transparent",
                            }}
                            onClick={this.onCompanyClick}
                          >
                            <span>
                              <img src="/assets/images/buildings.png" />{" "}
                              Company
                            </span>
                          </Link>
                        </li>
                      </ul>
                      <div className="tab_content">
                              {/* <div className="tabs_item">
                                <div className="row align-items-center">
                                  <div className="col-lg-12">
                                    <div className="services-tab-content">
                                      <div className="form-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder={
                                            this.state.isCompany
                                              ? "GSTIN"
                                              : "Aadhaar Number (Mandatory)"
                                          }
                                          name="aadhar"
                                          onBlur={this.form.handleBlurEvent}
                                          onChange={this.form.handleChangeEvent}
                                          value={this.state.fields.aadhar}
                                          data-attribute-name={
                                            this.state.isCompany
                                              ? "GSTIN"
                                              : "Aadhaar Number"
                                          }
                                        />
                                        <label className="error">
                                          {" "}
                                          {this.state.errors && this.state.errors.aadhar
                                            ? this.state.errors.aadhar
                                            : ""}
                                        </label>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div> */}
                              {/* ) : (
                            <div className="tabs_item">
                              <div className="row align-items-center">
                                <div className="col-lg-12">
                                  <div className="services-tab-content">
                                    <form action="/action_page.php">
                                      <div className="form-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="GSTIN"
                                          name="gst"
                                          onBlur={this.form.handleBlurEvent}
                                          onChange={this.form.handleChangeEvent}
                                          value={this.state.fields.gst}
                                        />
                                        <label className="error">
                                          * Min 3 Characters
                                        </label>
                                      </div>
                                    </form>
                                  </div>
                                </div>
                              </div>
                            </div>
                          )} */}
                      </div>
                    </div>
                    <div className="tab services-list-tab">
                      <div className="row">
                        <div className="col-6">
                          <p className="tab-title">Looking for</p>
                        </div>
                      </div>
                      <ul className="tabs tabs1" style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '15px',
                        width: '100%',
                        padding: 0,
                        listStyle: 'none'
                      }}>
                        <li style={{ width: '100%', maxWidth: '100%', marginLeft: '5px', marginRight: '5px' }}>
                          <Link
                            to="#"
                            style={{
                              border: '2px solid',
                              borderColor: this.state.selectedLookingFor === "freelance" ? "#F85100" : "#ddd",
                              display: 'block',
                              width: '100%',
                              padding: '15px 20px',
                              borderRadius: '8px',
                              textDecoration: 'none',
                              color: '#333',
                              transition: 'all 0.3s ease'
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              this.onProjectClick();
                            }}
                          >
                            <span>
                              Earn Money - Do jobs and get paid
                            </span>
                          </Link>
                        </li>
                        <li style={{ width: '100%', maxWidth: '100%', marginLeft: '5px', marginRight: '5px' }}>
                          <Link
                            to="#"
                            style={{
                              border: '2px solid',
                              borderColor: this.state.selectedLookingFor === "fulltime" ? "#F85100" : "#ddd",
                              display: 'block',
                              width: '100%',
                              padding: '15px 20px',
                              borderRadius: '8px',
                              textDecoration: 'none',
                              color: '#333',
                              transition: 'all 0.3s ease'
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              this.onServiceClick();
                            }}
                          >
                            <span>
                              Post Jobs - Hire people for work
                            </span>
                          </Link>
                        </li>
                        <li style={{ width: '100%', maxWidth: '100%', marginLeft: '5px', marginRight: '5px' }}>
                          <Link
                            to="#"
                            style={{
                              border: '2px solid',
                              borderColor: this.state.selectedLookingFor === "freelance,fulltime" ? "#F85100" : "#ddd",
                              display: 'block',
                              width: '100%',
                              padding: '15px 20px',
                              borderRadius: '8px',
                              textDecoration: 'none',
                              color: '#333',
                              transition: 'all 0.3s ease'
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              this.onBothClick();
                            }}
                          >
                            <span>
                              Both - Do both hiring and working
                            </span>
                          </Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                  
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Referral Code (Optional)"
                      name="referralCode"
                      onBlur={this.form.handleBlurEvent}
                      onChange={this.handleFieldChange}
                      style={{ textTransform: 'uppercase' }}
                      value={this.state.fields.referralCode}
                    />
                    <label className="error">
                      {this.state.errors && this.state.errors.referralCode
                        ? this.state.errors.referralCode
                        : ""}
                    </label>
                  </div>
                </form>
                  </div>
                  <div className="register-modal-footer">
                    <div className="form-group">
                      <input 
                        type="checkbox" 
                        id="terms2" 
                        name="terms" 
                        checked={this.state.termsAccepted}
                        onChange={this.handleTermsChange}
                      />
                      <label htmlFor="terms2">
                        I agree with <a href="/terms-and-conditions" target="_blank" className="terms-link" onClick={(e) => e.stopPropagation()}>Terms and Conditions</a> and <a href="/privacy-policy" target="_blank" className="terms-link" onClick={(e) => e.stopPropagation()}>Privacy Policy</a>
                      </label>
                    </div>
                    
                    <button 
                      type="button" 
                      className={`btn btn-default ${!this.state.isFormValid ? 'btn-disabled' : ''}`}
                      onClick={(e) => {
                        if (!this.state.isFormValid) {
                          e.preventDefault();
                          this.scrollToFirstEmptyField();
                          toast.error("Please fill in all required fields", {
                            position: "top-right",
                            autoClose: 3000,
                          });
                        } else {
                          this.handleStep2Submit();
                        }
                      }}
                    >
                      REGISTER NOW
                    </button>
                    
                  
                  </div>
                </div>
                <Loader loading={this.state.isregisterLoading} />
              </LoadingOverlay>
            </Modal>

        <Modal
          isOpen={this.state.successPopupOpen}
          onRequestClose={this.closeSuccessModal}
          style={customStyles}
          contentLabel="Example Modal"
          scrollable={true}
        >
          <div className="modal-dialog loginpopup" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">
                  Join <span>GigFWS</span> Group
                </h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={(e)=>{
                    this.redirect(e)
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="success">
                  <h1 className="title">Success</h1>
                  <img src="assets/images/success.png" />
                  <p>
                    You have successfully registered to be part of the GigFWS Group
                  </p>
                </div>
              </div>
              <div className="modal-footer">
                <div className="new">
                  <button
                    className="btn register"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={(e)=>{
                      this.redirect(e)
                    }}
                  >
                    CLOSE
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.termsPopupIsOpen}
          onRequestClose={this.closeTermsModal}
          style={customStyles}
          contentLabel="Example Modal"
          scrollable={true}
        >
          <div className="modal-dialog loginpopup" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Terms and Conditions</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={this.closeTermsModal}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="terms-condition">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </p>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </p>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </p>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </p>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </p>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </p>
                </div>
              </div>
              <div className="modal-footer">
                <div className="new">
                  <form>
                    <p>I agree with</p>
                    <div className="form-group">
                      <input type="checkbox" id="html" />
                      <label htmlFor="html">
                        Terms and Conditions
                        <br />
                        Privacy Policy
                      </label>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.privacyPopupIsOpen}
          onRequestClose={this.closePrivacyModal}
          style={customStyles}
          contentLabel="Example Modal"
          scrollable={true}
        >
          <div className="modal-dialog loginpopup" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Privacy Policy</h5>
                <button
                  type="button"
                  className="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={this.closePrivacyModal}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body">
                <div className="terms-condition">
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </p>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </p>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </p>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </p>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </p>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                    do eiusmod tempor incididunt ut labore et dolore magna
                    aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                    ullamco laboris nisi ut aliquip ex ea commodo consequat.
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum dolore eu fugiat nulla pariatur. Excepteur sint
                    occaecat cupidatat non proident, sunt in culpa qui officia
                    deserunt mollit anim id est laborum.
                  </p>
                </div>
              </div>
              <div className="modal-footer">
                <div className="new">
                  <form>
                    <div className="form-group">
                      <input type="checkbox" id="html" />
                    <p>I agree with</p>
                      <label htmlFor="html">
                        Terms and Conditions
                        <br />
                        Privacy Policy
                      </label>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          isOpen={this.state.loginModelIsOpen}
          onRequestClose={() => {
            this.closeLoginModal();
            document.body.classList.remove('modal-open');
          }}
          onAfterOpen={() => {
            document.body.classList.add('modal-open');
          }}
          style={loginModalStyles}
          contentLabel="Login Modal"
          scrollable={true}
        >
          <LoadingOverlay>
            <div className="login-modal">
              <div className="login-modal-header">
                <h5 className="login-modal-title">GigFWS Group</h5>
                <button
                  type="button"
                  className="login-close-btn"
                  onClick={() => {
                    this.closeLoginModal();
                    document.body.classList.remove('modal-open');
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="login-modal-body">
                <h2 className="welcome-text">Welcome back!</h2>
                <p className="instruction-text" style={{ color: '#f57e1f' }}>Enter your details to get sign in to your account</p>
                
                <form onSubmit={this.form.handleSubmit}>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Email ID or Mobile Number"
                      name="name"
                      onBlur={this.form.handleBlurEvent}
                      onChange={this.handleFieldChange}
                      value={this.state.fields.name}
                    />
                    <label className="error">
                      {this.state.errors && this.state.errors.name ? this.state.errors.name : ""}
                    </label>
                  </div>
                  
                  <div className="form-group password-sec">
                    <input
                      type="password"
                      className="form-control"
                      placeholder="Password"
                      name="password"
                      onBlur={this.form.handleBlurEvent}
                      onChange={this.handleFieldChange}
                      value={this.state.fields.password}
                      ref={this.inputRef}
                    />
                    <ReactPasswordToggleIcon 
                      inputRef={this.inputRef} 
                      showIcon={this.hideIcon}
                      hideIcon={this.showIcon}
                    />
                    <label className="error">
                      {this.state.errors && this.state.errors.password ? this.state.errors.password : ""}
                    </label>
                  </div>
                  
                  <button 
                    type="submit" 
                    className={`btn btn-default ${!this.state.isLoginFormValid ? 'btn-disabled' : ''}`}
                    disabled={this.state.isloginLoading}
                    onClick={(e) => {
                      if (!this.state.isLoginFormValid) {
                        e.preventDefault();
                        e.stopPropagation();
                        const nameField = document.querySelector('input[name="name"]');
                        const passwordField = document.querySelector('input[name="password"]');
                        
                        if (!this.state.fields.name && nameField) {
                          nameField.style.border = '1px solid #dc3545';
                          nameField.classList.add('validation-error');
                          setTimeout(() => {
                            nameField.style.removeProperty('border');
                            nameField.classList.remove('validation-error');
                          }, 3000);
                        }
                        
                        if (!this.state.fields.password && passwordField) {
                          passwordField.style.border = '1px solid #dc3545';
                          passwordField.classList.add('validation-error');
                          setTimeout(() => {
                            passwordField.style.removeProperty('border');
                            passwordField.classList.remove('validation-error');
                          }, 3000);
                        }
                        
                        toast.error("Please fill in all required fields", {
                          position: "top-right",
                          autoClose: 3000,
                        });
                      } else {
                      }
                    }}
                  >
                    {this.state.isloginLoading ? 'Signing in...' : 'Sign in'}
                  </button>
                  <div className="forgot-password-group" onClick={(e)=>{
                    e.preventDefault();
                    this.closeLoginModal();
                    this.openForgotPassModal();
                  }}>
                    <label className="forgot-password-link">Forgot Password?</label>
                  </div>
                  
                </form>
                
                <div className="social-login-section">
                  <div className="horizontal-line">
                    <span>Sign in with</span>
                  </div>
                  <ul className="social-login" style={{ display: 'flex', alignItems: 'center', listStyle: 'none', padding: 0, margin: 0 }}>
                          {/* <li>
                            <FacebookLogin
                              appId="550051726058276"
                              autoLoad={false}
                              fields="name,email,picture"
                              callback={this.responseFacebook}
                              render={renderProps => (
                                <a href="#" onClick={renderProps.onClick}>
                                  <img src={facebookImage} alt="Facebook" />
                                </a>
                              )}
                            />
                          </li> */}
                          <li>
                      <a href="#" onClick={e => { e.preventDefault(); this.linkedInLogin(); }}>
                        <img src={linkedinImage} alt="LinkedIn" />
                      </a>
                    </li>
                    <li>
                      <div style={{ position: 'relative', display: 'inline-block', width: '33px', height: '33px' }}>
                        <img 
                          src={googleImage} 
                          alt="Google" 
                          style={{ 
                            position: 'absolute',
                            top: '2px',
                            left: '0',
                            transition: 'all 0.2s ease',
                            zIndex: 1,
                            height: '33px',
                            width: '33px',
                          }}
                        />
                        <div style={{ 
                          position: 'absolute',
                          top: '2px',
                          left: '0',
                          width: '33px',
                          zIndex: 2,
                          opacity: 0.001,
                          cursor: 'pointer'
                        }}>
                          <GoogleLogin
                            ref={(googleButton) => { 
                              this.googleLoginButton = googleButton; 
                              if (googleButton && googleButton.querySelector) {
                                this.googleLoginDOMElement = googleButton;
                              }
                            }}
                            data-testid="google-login-button-login"
                            onSuccess={credentialResponse => {
                              const realUserData = getDecodedOAuthJwtGoogle(credentialResponse.credential)
                              realUserData.then(result => {
                                var index = result.getPayload().name.indexOf(' ');
                                var firstname = result.getPayload().name.substr(0, index);
                                var lastname = result.getPayload().name.substr(index+1);
                                this.socialLogin(firstname,lastname,result.getPayload().email,"gmail_login")
                              }).catch( err => (err));
                            }}
                            onError={() => {}}
                            theme="outline"
                            shape="circle"
                            size="large"
                            type="icon" 
                          />
                        </div>
                      </div>
                    </li>
                   
                  </ul>
                </div>
              </div>
            </div>
            <div className="login-loading-wrapper">
              <Loader loading={this.state.isloginLoading} />
            </div>
          </LoadingOverlay>
        </Modal>

        <Modal
          isOpen={this.state.mobileOTPPopupIsOpen}
          onRequestClose={this.closeMobileOTPModal}
          style={customStyles}
          contentLabel="Example Modal"
          scrollable={true}
        >
          <LoadingOverlay>
            <div>
              <div>
                <div
                  className="modal-dialog loginpopup dashboard signin"
                  role="document"
                >
                  <div className="modal-content">
                    <div>
                      <div className="modal-header">
                        <h5 className="modal-title">
                          Join <span>GigFWS</span> Group
                        </h5>
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                          onClick={this.closeMobileOTPModal}
                        >
                          <span aria-hidden="true">×</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <h2>Enter OTP from your mobile</h2>
                        <form onSubmit={this.form.handleSubmit}>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="OTP"
                              name="name"
                              onChange={(e) => {

                                if(e.target.value!=null)
                                this.setState({ mobileOTP: e.target.value });
                              }}
                              value={this.state.mobileOTP}
                            />
                            
                          </div>                         
                          <div className="form-group" onClick={(e)=>{
                            this.sendMobileOTP()
                          }}>                           

                            <label className="forgot"> <a href="#">Resend OTP</a></label>
                          </div>
                          <button  className="btn btn-default" onClick={()=>{
                            this.verifyMobileOTP()
                          }} >
                            Verify
                          </button>
                        </form>
                      </div>
                      <div className="modal-footer">
                       
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="login-loading-wrapper">
              <Loader loading={this.state.isloginLoading} />
            </div>
          </LoadingOverlay>
        </Modal>
        <Modal
          isOpen={this.state.emailOTPPopupIsOpen}
          onRequestClose={this.closeEmailOTPModal}
          style={customStyles}
          contentLabel="Example Modal"
          scrollable={true}
        >
          <LoadingOverlay>
            <div>
              <div>
                <div
                  className="modal-dialog loginpopup dashboard signin"
                  role="document"
                >
                  <div className="modal-content">
                    <div>
                      <div className="modal-header">
                        <h5 className="modal-title">
                          Join <span>GigFWS</span> Group
                        </h5>
                        <button
                          type="button"
                          className="close"
                          data-dismiss="modal"
                          aria-label="Close"
                          onClick={this.closeEmailOTPModal}
                        >
                          <span aria-hidden="true">×</span>
                        </button>
                      </div>
                      <div className="modal-body">
                        <h2>Enter OTP from email</h2>
                        <form onSubmit={this.form.handleSubmit}>
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              placeholder="OTP"
                              name="name"
                              onChange={(e) => {
                                if(e.target.value!=null)
                                this.setState({ emailOTP: e.target.value });
                              }}
                              value={this.state.emailOTP}
                            />
                            <div>
                              {" "}
                              
                            </div>
                          </div>
                        
                          <div className="form-group" onClick={(e)=>{
                            this.sendEmailOTP()
                          }}>
                          <label className="forgot"> <a href="#">Resend OTP</a></label>

                          </div>
                          <button className="btn btn-default" onClick={()=>{
                            this.verifyEmailOTP()
                          }} >
                            Verify
                          </button>
                        </form>
                      </div>
                      <div className="modal-footer">
                       
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="login-loading-wrapper">
              <Loader loading={this.state.isloginLoading} />
            </div>
          </LoadingOverlay>
        </Modal>
        <Modal
          isOpen={this.state.socialRegisterIsOpen}
          onRequestClose={this.closeSocialRegisterModal}
          style={customStyles}
          contentLabel="Example Modal"
          scrollable={true}
        >
                    <LoadingOverlay>

          <div>
            <div>
              <div className="modal-dialog loginpopup" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      Update <span>GigFWS</span> Profile
                    </h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      onClick={this.closeSocialRegisterModal}
                    >
                      <span aria-hidden="true">×</span>
                    </button>
                  </div>
                  <div className="modal-body">
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="First Name (Min. 1 and Max. 30 characters)"
                          name="firstName"
                          onChange={(e) => {
                            if(e.target.value!=null)
                            this.setState({ first_name: e.target.value });
                          }}
                          value={this.state.first_name}
                          maxLength="30"
                        />
                        <label className="error">
                          {" "}
                          {this.state.errors && this.state.errors.firstName
                            ? this.state.errors.firstName
                            : ""}
                        </label>
                      </div>
                      <div className="form-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Last Name (Min. 1 and Max. 30 characters)"
                          name="lastName"
                          onChange={(e) => {
                            if(e.target.value!=null)
                            this.setState({ last_name: e.target.value });
                          }}
                          value={this.state.last_name}
                          maxLength="30"
                        />
                        <label className="error">
                          {" "}
                          {this.state.errors && this.state.errors.lastName
                            ? this.state.errors.lastName
                            : ""}
                        </label>
                      </div>
                      <div className="form-group">
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Email ID"
                          name="email"
                          onChange={(e) => {
                            if(e.target.value!=null)
                            this.setState({ email: e.target.value });
                          }}
                          value={this.state.email}
                        />
                        <label className="error">
                          {" "}
                          {this.state.errors && this.state.errors.email
                            ? this.state.errors.email
                            : ""}
                        </label>
                      </div>
                      <div className="form-group">
                        <input
                          type="tel"
                          className="form-control"
                          placeholder="Mobile Number"
                          name="phone_number"
                          inputMode="numeric"
                          pattern="(?:\\+91[\\-\\s]?)?[6-9]\\d{9}"
                          title="Enter a valid mobile number"
                          maxLength="14"
                          onChange={(e) => {
                            const val = e.target.value ?? '';
                            this.setState((prev) => {
                              const digitsOnly = val.toString().trim().replace(/\\D/g, '');
                              const normalized = digitsOnly.startsWith('91') && digitsOnly.length === 12
                                ? digitsOnly.slice(2)
                                : (digitsOnly.startsWith('0') ? digitsOnly.slice(1) : digitsOnly);
                              const isValid = /^[6-9]\\d{9}$/.test(normalized);
                              return {
                                mobile: val,
                                errors: {
                                  ...(prev.errors || {}),
                                  phone_number: isValid ? '' : 'Enter a valid mobile number',
                                }
                              };
                            });
                          }}
                          value={this.state.mobile}
                        />
                        <label className="error">
                          {" "}
                          {this.state.errors && this.state.errors.phone_number
                            ? this.state.errors.phone_number
                            : ""}
                        </label>
                      </div>
                     
                      <button type="submit" className="btn btn-default" onClick={()=>{
                                     this.setState((state) => ({ 
                                       isSocialRegister: true,
                                       fields: {
                                         ...state.fields,
                                         firstName: state.first_name,
                                         lastName: state.last_name,
                                         email: state.email
                                       }
                                     }));
                                     this.closeSocialRegisterModal();
                                 this.openRegisterTwoModal();
                          }}  >
                        UPDATE
                      </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="login-loading-wrapper">
            <Loader loading={this.state.isloginLoading} />
          </div>
          </LoadingOverlay>
        </Modal>


        <Modal
          isOpen={this.state.forgotPassIsOpen}
          onRequestClose={this.closeForgotPassModal}
          style={forgotPassModalStyles}
          contentLabel="Forgot Password Modal"
          scrollable={true}
        >
          <LoadingOverlay>
            <div className="forgot-pass-modal">
              <div className="forgot-pass-modal-header">
                <h5 className="forgot-pass-modal-title">GigFWS Group</h5>
                <button
                  type="button"
                  className="forgot-pass-close-btn"
                  onClick={() => {
                    this.closeForgotPassModal();
                    document.body.classList.remove('modal-open');
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="forgot-pass-modal-body">
                <h2 className="welcome-text">Forgot Password?</h2>
                <p className="instruction-text">Enter your email or mobile number to reset your password</p>
                
                <div className="form-group">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter email or mobile number"
                    name="forgotpass"
                    onChange={(e) => {
                      if(e.target.value!=null) {
                        this.setState({ forgotpass: e.target.value }, () => {
                          this.validateForgotPasswordForm();
                        });
                      }
                    }}                          
                    value={this.state.forgotpass}
                  />
                  <label className="error">
                    {" "}
                    {this.state.errors && this.state.errors.forgotpass
                      ? this.state.errors.forgotpass
                      : ""}
                  </label>
                </div>
               
                <button 
                  type="submit" 
                  className={`btn btn-default ${!this.state.isForgotPassValid ? 'btn-disabled' : ''}`}
                  disabled={this.state.isloginLoading}
                  onClick={(e) => {
                    if (!this.state.isForgotPassValid) {
                      e.preventDefault();
                      const input = e.target.closest('.forgot-pass-modal-body').querySelector('input[name="forgotpass"]');
                      if (input) {
                        input.classList.add('validation-error');
                        setTimeout(() => {
                          input.classList.remove('validation-error');
                        }, 3000);
                      }
                      toast.error("Please enter your email or mobile number");
                    } else {
                  this.forgotpassword();
                    }
                  }}
                >
                  {this.state.isloginLoading ? "Submitting..." : "SUBMIT"}
                </button>
              </div>
            </div>
            <div className="login-loading-wrapper">
              <Loader loading={this.state.isloginLoading} />
            </div>
          </LoadingOverlay>
        </Modal>

        <Modal
          isOpen={this.state.resetPassIsOpen}
          onRequestClose={this.closeResetPassModal}
          style={customStyles}
          contentLabel="Example Modal"
          scrollable={true}
        >
                    <LoadingOverlay>

          <div>
  <div>
    <div className="modal-dialog loginpopup reset-your-password" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">
            Reset your <span>Password</span> 
          </h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={this.closeResetPassModal}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="form-group">
            <input
              type="text"
              className="form-control"
              placeholder="Enter OTP"
              name="otp"
              onChange={(e) => {
                if(e.target.value!=null)
                  this.setState({ otp: e.target.value });
              }}
              value={this.state.otp}
            />
                        <p style={{ textAlign: "right", marginBottom: "5px", marginTop: "5px" }}>
                          <span
                            style={{
                              cursor: (isForgotPassBlocked(this.state.forgotPassIdentifier) || isForgotPassOnCooldown(this.state.forgotPassIdentifier) || this.state.isloginLoading) ? 'not-allowed' : 'pointer',
                              color: (isForgotPassBlocked(this.state.forgotPassIdentifier) || isForgotPassOnCooldown(this.state.forgotPassIdentifier) || this.state.isloginLoading) ? '#999' : '#007bff',
                              opacity: (isForgotPassBlocked(this.state.forgotPassIdentifier) || isForgotPassOnCooldown(this.state.forgotPassIdentifier) || this.state.isloginLoading) ? 0.6 : 1,
                              fontSize: '14px',
                              userSelect: 'none'
                            }}
                            onClick={(e) => {
                              e.preventDefault(); 
                              e.stopPropagation(); 
                              if (!this.state.isloginLoading && !isForgotPassBlocked(this.state.forgotPassIdentifier) && !isForgotPassOnCooldown(this.state.forgotPassIdentifier)) {
                                this.forgotpassword();
                              }
                            }}
                            onMouseDown={(e) => {
                              e.preventDefault(); 
                            }}
                          >
                            Resend OTP
                          </span>
                        </p>
            {(isForgotPassBlocked(this.state.forgotPassIdentifier) || (this.state.remainingForgotPassMinutes && this.state.remainingForgotPassMinutes > 0) || (this.state.remainingForgotPassCooldownSeconds && this.state.remainingForgotPassCooldownSeconds > 0)) && (
              <div style={{
                textAlign: "center",
                padding: '8px',
                backgroundColor: '#fff3cd',
                border: '1px solid #ffc107',
                borderRadius: '4px',
                marginBottom: '15px'
              }}>
                <p style={{
                  color: '#856404',
                  fontSize: '13px',
                  margin: 0,
                  fontWeight: '500'
                }}>
                  {this.state.remainingForgotPassCooldownSeconds && this.state.remainingForgotPassCooldownSeconds > 0 ? (
                    <>⏰ Please wait {this.state.remainingForgotPassCooldownSeconds} {this.state.remainingForgotPassCooldownSeconds === 1 ? 'second' : 'seconds'} before resending OTP</>
                  ) : (
                    <>⏰ Please wait for {this.state.remainingForgotPassMinutes || getForgotPassRemainingTime(this.state.forgotPassIdentifier)} {this.state.remainingForgotPassMinutes === 1 ? 'minute' : 'minutes'} before resending OTP</>
                  )}
                </p>
              </div>
            )}
          </div>
          
                      <div className="form-group new-password">
                        <input
                          type="password"
                          className="form-control"
                          placeholder="New Password (8 chars, 1 uppercase, 1 number, 1 special)"
                          name="newpassword"
                          onChange={(e) => {
                            if(e.target.value!=null)
                            this.setState({ newPass: e.target.value });
                          }}
                          value={this.state.newPass}
                          ref = {this.newPassword1}
                          />

                           <ReactPasswordToggleIcon 
                            inputRef={this.newPassword1} 
                            showIcon={this.hideIcon}
                            hideIcon={this.showIcon}
                          />   

                        
                        <label className="error">
                          {" "}
                          {this.state.errors && this.state.errors.forgotpass
                            ? this.state.errors.forgotpass
                            : ""}
                        </label>
                      </div>
                      <div className="form-group cnew-password">
                        <input
                          type="password"
                          className="form-control"
                          placeholder="Confirm New Password"
                          name="confirmpass"
                          onChange={(e) => {
                            if(e.target.value!=null)
                            this.setState({ confirmNewpass: e.target.value });
                          }}
                          value={this.state.confirmNewpass}
                          ref = {this.confirmNewPassword}
                        />
                        <ReactPasswordToggleIcon 
                            inputRef={this.confirmNewPassword} 
                            showIcon={this.hideIcon}
                            hideIcon={this.showIcon}
                          /> 
                        <label className="error">
                          {" "}
                          {this.state.errors && this.state.errors.forgotpass
                            ? this.state.errors.forgotpass
                            : ""}
                        </label>
                      </div>
                      <button type="submit" className="btn btn-default" onClick={()=>{
                                 this.resetpassword();
                          }}  >
                        SUBMIT
                      </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="login-loading-wrapper">
            <Loader loading={this.state.isloginLoading} />
          </div>
          </LoadingOverlay>
        </Modal>


      </div>
    );
  }
}

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "100%",
    height: "100%",
    background: "transparent",
  },
  overlay: { zIndex: 1000 },
};

const loginModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "auto",
    height: "auto",
    maxHeight: "90vh",
    background: "transparent",
    border: "none",
    padding: "0",
    overflow: "hidden",
  },
  overlay: { 
    zIndex: 1000,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    backdropFilter: "blur(3px)",
    WebkitBackdropFilter: "blur(3px)",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
};

const forgotPassModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    width: "auto",
    height: "auto",
    maxHeight: "90vh",
    background: "transparent",
    border: "none",
    padding: "0",
    overflow: "auto",
  },
  overlay: { 
    zIndex: 1000,
    backgroundColor: "rgba(0, 0, 0, 0.4)",
    backdropFilter: "blur(3px)",
    WebkitBackdropFilter: "blur(3px)",
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  },
};
export default  connect(mapStateToProps, mapDispatchToProps)(withRouter(Header));
